<!--公司介绍-->
<template>
  <div class="serve1">
    <!--顶部介绍-->
    <picture>
      <source media="(min-width: 768px)" srcset="@/assets/img/pc/about/about2/bakTop.png">
      <source media="(min-width: 320px)" srcset="@/assets/img/mobile/about/about2/bakTop.png">
      <img class="bakTop" src="@/assets/img/pc/about/about2/bakTop.png">
    </picture>
    <breadcrumb :guide="guide"></breadcrumb>
    <!--主体内容-->

    <div class="x-container">
      <!--分页器（产品激活、流程管理）-->
      <div class="changePageButtonContainer">
        <div class="changePageButton">
          <span @click="changePage(true)" class="pageBtn" :class="{ 'active': showRegister }">激活申请</span>
          <span class="point"></span>
          <span @click="changePage(false)" class="pageBtn" :class="{ 'active': !showRegister }">流程管理</span>
        </div>
      </div>

      <!--注册申请-->
      <div v-show="showRegister">
        <!--表单-->
        <section class="productRegister">
          <el-form class="form" :model="form" ref="productForm" :label-position='labelPosition' :inline="true"
            :rules="rules">
            <!--产品类型-->
            <el-form-item class="productType" style="width: 100%" label-width="7.5rem" label="产品类型" prop="productType">
              <el-select v-model="form.productType" class="product_registration_selection" @change="changeProductType">
                <el-option v-for="(item, index) in selection.productTypes" :key="'productType' + index"
                  :value="item.productTypeId" :label="item.productTypeName"></el-option>
              </el-select>
            </el-form-item>
            <!--产品套餐/型号-->
            <el-form-item class="productType" style="width: 100%" label-width="7.5rem" label="产品套餐/型号"
              prop="productSetMeal">
              <el-select filterable v-model="form.productSetMeal" class="product_registration_selection"
                @change="changeProductSetMeal">
                <el-option v-for="(item, index) in selection.productSetMeals" :key="'productType' + index"
                  :value="item.id" :label="item.name"></el-option>
              </el-select>
            </el-form-item>
            <!--点位型号-->
            <!--<el-form-item v-if="showPointTypeItem" class="productType" style="width: 100%" label-width="7.5rem" label="点位型号"-->
            <!--              prop="productPointType">-->
            <!--  <el-select filterable v-model="form.productPointType" class="product_registration_selection">-->
            <!--    <el-option v-for="(item,index) in selection.pointTypes" :key="'productType'+index" :value="item.value"-->
            <!--               :label="item.label"></el-option>-->
            <!--  </el-select>-->
            <!--</el-form-item>-->
            <!-- 销售类型 -->
            <el-form-item class="productType" style="width: 100%" label-width="7.5rem" label="销售类型" prop="salesType">
              <el-select v-model="form.salesType" class="product_registration_selection" @change="changeAddrOPE"
                :disabled="disabledSalesType">
                <el-option v-for="(item, index) in selection.salesTypes" :key="'salesType' + index" :value="item.value"
                  :label="item.label"></el-option>
              </el-select>
            </el-form-item>
            <!--订单编号-Logic展示-->
            <el-form-item v-if="setMealIsLogicInPage" class="activedCode mockMust" style="width: 100%"
              label-width="7.5rem" :inline="false" label="订单编号">
              <el-input placeholder="示例：YUX25010001/YUXSF25010001/江西251000/江西SF251000"
                v-model="formForLogic.orderNumber" :disabled="true"></el-input>
            </el-form-item>
            <!--订单编号-->
            <el-form-item v-else class="activedCode" style="width: 100%" label-width="7.5rem" :inline="false"
              label="订单编号" prop="orderNumber">
              <el-input placeholder="示例：YUX25010001/YUXSF25010001/江西251000/江西SF251000" v-model="form.orderNumber"
                :maxlength="100"></el-input>
            </el-form-item>
            <!--订单截图-->
            <el-form-item class="transparentStar" label="订单截图" prop="orderImg" label-width="7.5rem">
              <div>
                <el-upload :disabled="setMealIsLogicInPage" class="avatar-uploader"
                  :class="{ 'onlyOneImgUploader': form.orderImg.imageUrlArr.length !== 0, 'disabledUpload': setMealIsLogicInPage }"
                  accept="image/png,image/jpeg" list-type="picture-card" action="" :limit=1
                  :file-list="form.orderImg.imageUrlArr" :on-preview="handlePictureCardPreview"
                  :http-request="uploadImage" :before-upload="beforeUploadImage" :on-remove="handleRemoveImage">
                  <i class="el-icon-plus"></i>
                </el-upload>
                <div
                  style="font-size: 14px;color: #333333;word-break: break-word;line-height: 1.2;text-align: left;padding-top: 5px;">
                  注：仅支持jpg、png、jpeg的图片格式，图片大小2M以内，上传图片尺寸无限制；<br>订单截图需包含订单编号以及下单清单
                </div>
              </div>
              <el-dialog append-to-body :visible.sync="imgPreviewVisible">
                <img width="100%" :src="form.orderImg.imageUrl" alt="">
              </el-dialog>
            </el-form-item>
            <!--工程名称-Logic展示-->
            <el-form-item v-if="setMealIsLogicInPage" class="activedCode mockMust" style="width: 100%"
              label-width="7.5rem" :inline="false" label="工程名称">
              <el-input placeholder="请输入工程名称..." v-model="formForLogic.belongToProject" :disabled="true"></el-input>
            </el-form-item>
            <!--工程名称-->
            <el-form-item v-else class="activedCode" style="width: 100%" label-width="7.5rem" :inline="false"
              label="工程名称" prop="belongToProject">
              <el-input placeholder="请输入工程名称..." v-model="form.belongToProject" maxlength="20"></el-input>
            </el-form-item>
            <!--申请单位-->
            <!--<el-form-item class="activedCode" style="width: 100%" label-width="7.5rem" :inline="false" label="申请单位"-->
            <!--              prop="applicationUnit">-->
            <!--  <el-input placeholder="请输入申请单位..." v-model="form.applicationUnit" :maxlength="20"></el-input>-->
            <!--</el-form-item>-->
            <!--工程地点-Logic展示-->
            <div class="eng" v-if="showProvinceCity && setMealIsLogicInPage">
              <span class="tit">工程地点</span>
              <el-row class="row2">
                <el-form-item class="engineeringAddress">
                  <el-select v-model="formForLogic.province" class="product_registration_selection disabledSelect"
                    :disabled="true">
                  </el-select>
                  <span style="margin-left: 10px">省/直辖市</span>
                </el-form-item>
                <el-form-item>
                  <el-select v-model="formForLogic.city" class="product_registration_selection disabledSelect"
                    :disabled="true">
                  </el-select>
                  <span style="margin-left: 10px">市</span>
                </el-form-item>
              </el-row>
            </div>
            <!--工程地点-->
            <div class="eng" v-if="showProvinceCity && !setMealIsLogicInPage">
              <span class="tit">工程地点</span>
              <el-row class="row2">
                <el-form-item class="engineeringAddress" prop="province">
                  <el-select v-model="form.province" @change="changeProvince" class="product_registration_selection">
                    <el-option v-for="(item, index) in selection.provinces" :key="'provinces' + index" :value="item.id"
                      :label="item.name"></el-option>
                  </el-select>
                  <span style="margin-left: 10px">省/直辖市</span>
                </el-form-item>
                <el-form-item prop="city">
                  <el-select v-model="form.city" class="product_registration_selection">
                    <el-option v-for="(item, index) in selection.cities" :key="'cities' + index" :value="item.id"
                      :label="item.name"></el-option>
                  </el-select>
                  <span style="margin-left: 10px">市</span>
                </el-form-item>
              </el-row>
            </div>
            <!--详细地址-Logic展示-->
            <el-form-item v-if="setMealIsLogicInPage" class="addressDetail"
              :class="{ noRequiredFlag: showProvinceCity }" style="width: 100%" label-width="7.5rem" :inline="false"
              :label="addrLabel">
              <el-input placeholder="请输入详细地址..." v-model="formForLogic.addressDetail" :disabled="true"></el-input>
            </el-form-item>
            <!--详细地址-->
            <el-form-item v-else class="addressDetail" :class="{ noRequiredFlag: showProvinceCity }" style="width: 100%"
              label-width="7.5rem" :inline="false" :label="addrLabel" prop="addressDetail">
              <el-input placeholder="请输入详细地址..." v-model="form.addressDetail" maxlength="200"></el-input>
            </el-form-item>
            <!--备注-->
            <el-form-item class="activedCode transparentStar" style="width: 100%" label-width="7.5rem" :inline="false"
              label="备注" prop="remark">
              <el-input placeholder="请输入备注..." v-model="form.remark" maxlength="200"></el-input>
            </el-form-item>
            <!--序列号-->
            <!--滚动条样式-->
            <!--<template v-for="(item, index) in form.seriesNumber">-->
            <!--  <div :key="'seriesNumber'+index" style="position:relative;">-->
            <!--    <el-form-item class="activedCode" style="width: 100%" label-width="7.5rem" :inline="false" :label="'序列号'+(index+1)"-->
            <!--                  :prop="'seriesNumber.'+index"-->
            <!--                  :rules="{ required: true, message: '请输入软件序列号', trigger: 'blur' }"-->
            <!--    >-->
            <!--      <el-input placeholder="请输入软件激活码..." v-model="form.seriesNumber[index]"></el-input>-->
            <!--      <i class="el-icon-circle-plus-outline leftIcon1" @click="addRow()"></i>-->
            <!--      <i class="el-icon-remove-outline leftIcon2" v-if="index!=0" @click="reduceRow(index)"></i>-->
            <!--    </el-form-item>-->
            <!--  </div>-->
            <!--</template>-->
            <!--序列号-单条-->
            <el-form-item v-if="setMealIsLogicInPage" class="activedCode" style="width: 100%" label-width="7.5rem"
              :inline="false" label="序列号" prop="seriesNumberOnce"
              :rules="{ required: true, message: '序列号不能为空', trigger: 'blur' }">
              <el-input placeholder="请输入序列号..." v-model.trim="form.seriesNumberOnce" @paste.native="(e) => handlePaste(e, 'single', {
                aimEntity: 'form',
                propertyName: 'seriesNumberOnce'
              })"></el-input>
            </el-form-item>
            <!--序列号-分页样式-->
            <el-form-item v-else class="activedCode" style="width: 100%" label-width="7.5rem" :inline="false"
              label="序列号" prop="seriesNumber" :rules="[{ required: true, message: '请添加软件序列号', trigger: 'blur' },
              { validator: this.requiredSeriesNumber, trigger: ['blur', 'change'] }]">
              <!--按钮栏-->
              <div class="opeBar">
                <div class="btnForPub btnMr" @click="addRow()">添加</div>
                <div class="btnForPub btnMr" @click="patchDelete()">批量删除</div>
                <!--todo 导入待做-->
                <!--<div class="btnForPub">导入</div>-->
              </div>
              <el-form :model="form" ref="regForm" label-width="auto">
                <el-table
                  :data="form.seriesNumber.slice((seriesNumberPagination.currentPage - 1) * seriesNumberPagination.pageSize, seriesNumberPagination.currentPage * seriesNumberPagination.pageSize)"
                  @selection-change="handleSelectionChange" class="flowTableClass"
                  header-row-class-name="flowTableHeader" style="width: 100%" center stripe>
                  <el-table-column type="selection" align="center" width="45">
                  </el-table-column>
                  <el-table-column label="序号" align="center" width="120">
                    <template slot-scope="scope">{{ (seriesNumberPagination.currentPage - 1) *
                      seriesNumberPagination.pageSize +
                      scope.$index + 1 }}</template>
                  </el-table-column>
                  <el-table-column label="激活码" align="center">
                    <template slot-scope="scope">
                      <el-form-item class="relativeError" style="width: 450px;"
                        :prop="'seriesNumber[' + ((seriesNumberPagination.currentPage - 1) * seriesNumberPagination.pageSize + scope.$index) + '].number'"
                        :rules="{ required: true, message: '激活码不能为空', trigger: 'blur' }">
                        <el-input style="width: 420px;"
                          v-model.trim="form.seriesNumber[(seriesNumberPagination.currentPage - 1) * seriesNumberPagination.pageSize + scope.$index].number"
                          placeholder="请输入" @paste.native="(e) => handlePaste(e, 'multiple', {
                            aimEntity: 'form',
                            currentPage: seriesNumberPagination.currentPage - 1,
                            pageSize: seriesNumberPagination.pageSize,
                            index: scope.$index
                          })"></el-input>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="center" width="120">
                    <template slot-scope="scope">
                      <div
                        @click="reduceRow((seriesNumberPagination.currentPage - 1) * seriesNumberPagination.pageSize + scope.$index)"
                        class="opeBtn">删除</div>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination class="pagination" style="margin-top: 16px;text-align: center;"
                  @size-change="handleSizeChange" @current-change="handleCurrentChange"
                  :current-page="seriesNumberPagination.currentPage" :page-sizes="[5, 10, 20, 50]"
                  :page-size="seriesNumberPagination.pageSize" layout="total, sizes, prev, pager, next, jumper"
                  :total="form.seriesNumber.length">
                </el-pagination>
              </el-form>
            </el-form-item>
            <!--提交按钮-->
            <div style="text-align: center;margin-bottom: 40px;">
              <span class="x-btn" @click="beforeConfirm">提交申请</span>
            </div>
          </el-form>
        </section>
        <!--产品激活步骤-->
        <section>
          <p class="title">产品激活流程</p>
          <picture>
            <source media="(min-width: 768px)" srcset="@/assets/img/pc/serve/serve1/pic1new3.png">
            <source media="(min-width: 320px)" srcset="@/assets/img/mobile/serve/serve1/pic1new3.png">
            <img style="width: 80%;" src="@/assets/img/pc/serve/serve1/pic1new3.png">
          </picture>
        </section>
      </div>
      <!--流程管理-->
      <!--<div v-show="!showRegister">-->
      <!--  <section class="registerTableContainer">-->
      <!--    <el-table-->
      <!--      :data="currentPageFlowData"-->
      <!--      center-->
      <!--      stripe-->
      <!--      class="flowTableClass"-->
      <!--      header-row-class-name="flowTableHeader"-->
      <!--      style="width: 100%">-->
      <!--      <el-table-column-->
      <!--        prop="no"-->
      <!--        label="序号"-->
      <!--        align="center"-->
      <!--        width="60"-->
      <!--      >-->
      <!--      </el-table-column>-->
      <!--      <el-table-column-->
      <!--        prop="type"-->
      <!--        label="申请产品类型"-->
      <!--      >-->
      <!--      </el-table-column>-->
      <!--      <el-table-column-->
      <!--        prop="time"-->
      <!--        label="申请时间"-->
      <!--      >-->
      <!--      </el-table-column>-->
      <!--      <el-table-column label="节点流程" align="left">-->
      <!--        <template slot-scope="scope">-->
      <!--          <ProcessNode :flowType="1" :flowStatus="scope.row.flowStatus" :downCode="scope.row.downCode"-->
      <!--                       :registerId="scope.row.registerId"/>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <!--    </el-table>-->
      <!--    <el-pagination-->
      <!--      class="pagination"-->
      <!--      style="margin-top: 16px;"-->
      <!--      @size-change="newsTableSizeChange"-->
      <!--      @current-change="newsTableCurrentChange"-->
      <!--      :current-page="flowPagination.currentPage"-->
      <!--      :page-sizes="[5, 10, 20, 50]"-->
      <!--      :page-size="flowPagination.pageSize"-->
      <!--      layout="total, sizes, prev, pager, next, jumper"-->
      <!--      :total="flowTableData.length">-->
      <!--      &lt;!&ndash;<span class="customizeJumpPage">&ndash;&gt;-->
      <!--      &lt;!&ndash;<span class="customizeJumpPageText">&ndash;&gt;-->
      <!--      &lt;!&ndash;前往&ndash;&gt;-->
      <!--      &lt;!&ndash;<input type="text" class="customizeJumpPageInput" v-model="flowPagination.jumpPage">&ndash;&gt;-->
      <!--      &lt;!&ndash;页&ndash;&gt;-->
      <!--      &lt;!&ndash;</span>&ndash;&gt;-->
      <!--      &lt;!&ndash;<button @click="newsJumpToPage" class="customizeJumpPageButton">跳转</button>&ndash;&gt;-->
      <!--      &lt;!&ndash;</span>&ndash;&gt;-->
      <!--    </el-pagination>-->
      <!--  </section>-->
      <!--</div>-->
      <!--流程管理(新)-->
      <div v-show="!showRegister">
        <section class="registerTableContainer" style="width: 100%;">
          <div class="topBar">
            <span class="searchTitle">产品类型</span>
            <el-select v-model="search.productType" class="ml10" @change="changeProductTypeInRecord" clearable>
              <el-option v-for="(item, index) in search.productTypes" :key="'productTypeInSearch' + index"
                :value="item.productTypeId" :label="item.productTypeName"></el-option>
            </el-select>
            <span class="searchTitle ml10">产品套餐/型号</span>
            <el-select filterable v-model="search.productSetMeal" class="ml10" @change="searchData" clearable>
              <el-option v-for="(item, index) in search.productSetMeals" :key="'productSetMealInSearch' + index"
                :value="item.id" :label="item.name"></el-option>
            </el-select>
            <!--<el-date-picker type="datetimerange"-->
            <!--                class="ml10"-->
            <!--                v-model="search.timeRange"-->
            <!--                range-separator="至"-->
            <!--                start-placeholder="开始日期"-->
            <!--                end-placeholder="结束日期"-->
            <!--                @change="searchData"-->
            <!--&gt;</el-date-picker>-->
            <span class="searchTitle ml10">申请状态</span>
            <el-select filterable v-model="search.flowStatus" class="ml10" @change="searchData" clearable>
              <el-option v-for="(item, index) in statuss" :key="'statussInSearch' + index" :value="item.value"
                :label="item.label"></el-option>
            </el-select>
            <el-input class="ml10" style="width: 200px;" v-model="search.keyWords" placeholder="请输入" clearable
              @clear="searchData" @keyup.enter.native="searchData">
              <i slot="suffix" style="cursor: pointer;" class="el-input__icon el-icon-search" @click="searchData"></i>
            </el-input>
          </div>
          <el-table :data="flowMngTableData" center stripe class="flowTableClass"
            header-row-class-name="flowTableHeader" cell-class-name="cellStyle" style="width: 100%">
            <el-table-column type="index" label="序号" align="center" width="60">
            </el-table-column>
            <el-table-column prop="productTypeName" align="center" label="产品类型">
            </el-table-column>
            <el-table-column prop="productPackageName" align="center" label="产品套餐/型号">
            </el-table-column>
            <!--<el-table-column-->
            <!--  align="center"-->
            <!--  label="点位型号"-->
            <!--&gt;-->
            <!--  <template slot-scope="scope">-->
            <!--    {{scope.row.productPointType ? pointTypeOptions.find(item => item.value === scope.row.productPointType).label : '/'}}-->
            <!--  </template>-->
            <!--</el-table-column>-->
            <el-table-column prop="engineeringName" align="center" label="工程名称">
            </el-table-column>
            <el-table-column width="160" align="center" prop="applicationTime" label="申请时间">
            </el-table-column>
            <el-table-column align="center" label="申请状态">
              <template slot-scope="scope">
                <div style="display: inline-block;">{{ statusList[scope.row.flowStatus] }}</div>
                <div v-if="statusList[scope.row.flowStatus] === '审核通过'" class="opeBtn canUse downloadBtn"
                  @click="downloadCertificate(scope)">证书下载</div>
              </template>
            </el-table-column>
            <el-table-column width="170" align="center" prop="time" label="操作">
              <template slot-scope="scope">
                <div @click="clickCancel(scope)" class="opeBtn btnMr" v-if="[1, 2, 5].includes(scope.row.flowStatus)"
                  :class="{
                    'banUse': !btnCanUse(statusList[scope.row.flowStatus], '取消'),
                    'canUse': btnCanUse(statusList[scope.row.flowStatus], '取消')
                  }">取消</div>
                <div @click="clickConfirm(scope)" class="opeBtn btnMr" v-else :class="{
                  'banUse': !btnCanUse(statusList[scope.row.flowStatus], '提交'),
                  'canUse': btnCanUse(statusList[scope.row.flowStatus], '提交')
                }">提交</div>
                <div @click="clickShowDtl(scope)" class="opeBtn btnMr" :class="{
                  'banUse': !btnCanUse(statusList[scope.row.flowStatus], '详情'),
                  'canUse': btnCanUse(statusList[scope.row.flowStatus], '详情')
                }">详情</div>
                <div @click="clickEdit(scope)" class="opeBtn btnMr" :class="{
                  'banUse': !btnCanUse(statusList[scope.row.flowStatus], '编辑'),
                  'canUse': btnCanUse(statusList[scope.row.flowStatus], '编辑')
                }">编辑</div>
                <div @click="clickDelete(scope)" class="opeBtn" :class="{
                  'banUse': !btnCanUse(statusList[scope.row.flowStatus], '删除'),
                  'canUse': btnCanUse(statusList[scope.row.flowStatus], '删除')
                }">删除</div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination class="pagination" style="margin-top: 16px;" @size-change="searchPageSizeChange"
            @current-change="searchCurrentPageChange" :current-page="search.currentPage" :page-sizes="[5, 10, 15]"
            :page-size="search.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="search.total">
          </el-pagination>
        </section>
      </div>
    </div>

    <!--申请通过的提示弹窗-->
    <el-dialog class="loginDialog" title="" :visible.sync="successRegister" width="400px" :close-on-click-modal="false"
      :close-on-press-escape="false" :show-close="false" center>
      <!-- 提示 -->
      <div class="loginDialog__wrap">
        <div class="loginDialog__wrap__title">
          {{ registerResultTitle }}
          <i class="el-icon-close" @click="successRegister = false"></i>
        </div>
        <div class="loginDialog__wrap__content">
          <div class="tips">
            <template v-if="registerResultCode === '100'">
              <img src="../../../assets/img/common/wraning.png" alt="">
            </template>
            <template v-else>
              <i class="el-icon-error registerFailIcon"></i>
            </template>

            <div style="padding-left: 12px;font-size: 16px;">
              {{ registerResultContent }}
            </div>
          </div>
          <div class="login-btn-container">
            <div class="login-btn" @click="successRegister = false">确认</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!--编辑弹窗-->
    <el-dialog :visible.sync="editVisible" width="800px" @closed="closeEditDialog" :close-on-click-modal="false">
      <div slot="title" class="dialogTitle">编辑申请</div>
      <el-form ref="applyForm" style="text-align: left;" label-position="right" label-width="140px"
        :model="editFlowEntity" :rules="rules">
        <!--产品类型-->
        <el-form-item class="productType" style="width: 100%" label-width="7.5rem" label="产品类型" prop="productType">
          <el-select v-model="editFlowEntity.productType" class="product_registration_selection"
            @change="changeProductTypeInEdit" style="width: 420px;">
            <el-option v-for="(item, index) in editSelection.productTypes" :key="'productTypeInEdit' + index"
              :value="item.productTypeId" :label="item.productTypeName"></el-option>
          </el-select>
        </el-form-item>
        <!--产品套餐/型号-->
        <el-form-item class="productType" style="width: 100%" label-width="7.5rem" label="产品套餐/型号"
          prop="productSetMeal">
          <el-select filterable v-model="editFlowEntity.productSetMeal" class="product_registration_selection"
            @change="changeProductSetMealInEdit" style="width: 420px;">
            <el-option v-for="(item, index) in editSelection.productSetMeals" :key="'productTypeInEdit' + index"
              :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <!--点位型号-->
        <!--<el-form-item v-if="showPointTypeItemInEdit" class="productType" style="width: 100%" label-width="7.5rem" label="点位型号"-->
        <!--              prop="productPointType">-->
        <!--  <el-select filterable v-model="editFlowEntity.productPointType" class="product_registration_selection"-->
        <!--             style="width: 420px;">-->
        <!--    <el-option v-for="(item,index) in editSelection.pointTypes" :key="'productTypeInEdit'+index" :value="item.value"-->
        <!--               :label="item.label"></el-option>-->
        <!--  </el-select>-->
        <!--</el-form-item>-->
        <!-- 销售类型 -->
        <el-form-item class="productType" style="width: 100%" label-width="7.5rem" label="销售类型" prop="salesType">
          <el-select v-model="editFlowEntity.salesType" class="product_registration_selection"
            @change="changeAddrOPEInEdit" :disabled="disabledSalesTypeInEdit" style="width: 420px;">
            <el-option v-for="(item, index) in selection.salesTypes" :key="'salesType' + index" :value="item.value"
              :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <!--订单编号-Logic展示-->
        <el-form-item v-if="setMealIsLogicInDialog" class="activedCode mockMust" style="width: 100%"
          label-width="7.5rem" :inline="false" label="订单编号">
          <el-input placeholder="请输入订单编号..." v-model="formForLogic.orderNumber" style="width: 420px;"
            :disabled="true"></el-input>
        </el-form-item>
        <!--订单编号-->
        <el-form-item v-else class="activedCode" style="width: 100%" label-width="7.5rem" :inline="false" label="订单编号"
          prop="orderNumber">
          <el-input placeholder="请输入订单编号..." v-model="editFlowEntity.orderNumber" style="width: 420px;"
            :maxlength="100"></el-input>
        </el-form-item>
        <!--订单截图-->
        <el-form-item class="transparentStar" label="订单截图" prop="orderImg" label-width="7.5rem">
          <div>
            <el-upload :disabled="setMealIsLogicInDialog" class="avatar-uploader"
              :class="{ 'onlyOneImgUploader': editFlowEntity.orderImg.imageUrlArr.length !== 0, 'disabledUpload': setMealIsLogicInDialog }"
              accept="image/png,image/jpeg" list-type="picture-card" action="" :limit=1
              :file-list="editFlowEntity.orderImg.imageUrlArr" :on-preview="handlePictureCardPreviewInEdit"
              :http-request="uploadImageInEdit" :before-upload="beforeUploadImage" :on-remove="handleRemoveImageInEdit">
              <i class="el-icon-plus"></i>
            </el-upload>
            <div
              style="font-size: 14px;color: #333333;word-break: break-word;line-height: 1.2;text-align: left;padding-top: 5px;">
              注：仅支持jpg、png、jpeg的图片格式，图片大小2M以内，上传图片尺寸无限制；<br>订单截图需包含订单编号以及下单清单
            </div>
          </div>
          <el-dialog append-to-body :visible.sync="imgPreviewVisibleInEdit">
            <img width="100%" :src="editFlowEntity.orderImg.imageUrl" alt="">
          </el-dialog>
        </el-form-item>
        <!--工程名称-Logic展示-->
        <el-form-item v-if="setMealIsLogicInDialog" class="activedCode" style="width: 100%" label-width="7.5rem"
          :inline="false" label="工程名称">
          <el-input placeholder="请输入工程名称..." v-model="formForLogic.belongToProject" style="width: 420px;"
            :disabled="true"></el-input>
        </el-form-item>
        <!--工程名称-->
        <el-form-item v-else class="activedCode" style="width: 100%" label-width="7.5rem" :inline="false" label="工程名称"
          prop="belongToProject">
          <el-input placeholder="请输入工程名称..." v-model="editFlowEntity.belongToProject" maxlength="20"
            style="width: 420px;"></el-input>
        </el-form-item>
        <!--申请单位-->
        <!--<el-form-item class="activedCode" style="width: 100%" label-width="7.5rem" :inline="false" label="申请单位"-->
        <!--              prop="applicationUnit">-->
        <!--  <el-input placeholder="请输入申请单位..." v-model="editFlowEntity.applicationUnit" :maxlength="20" style="width: 420px;"></el-input>-->
        <!--</el-form-item>-->
        <!--工程地点-Logic展示-->
        <div style="display: flex;" v-if="showProvinceCityInEdit && setMealIsLogicInDialog">
          <div style="display: inline-block;width: 180px;height: 40px;line-height: 40px;text-align: right;">
            <span style="color: #F56C6C">*</span><span style="padding-right: 12px;">工程地点</span>
          </div>
          <div class="editPCStyle">
            <el-form-item class="">
              <el-select v-model="formForLogic.province" class="product_registration_selection disabledSelectInDialog"
                :disabled="true">
              </el-select>
              <span style="margin: 0 10px">省/直辖市</span>
            </el-form-item>
            <el-form-item>
              <el-select v-model="formForLogic.city" class="product_registration_selection disabledSelectInDialog"
                :disabled="true">
              </el-select>
              <span style="margin-left: 10px">市</span>
            </el-form-item>
          </div>
        </div>
        <!--工程地点-->
        <div style="display: flex;" v-if="showProvinceCityInEdit && !setMealIsLogicInDialog">
          <div style="display: inline-block;width: 180px;height: 40px;line-height: 40px;text-align: right;">
            <span style="color: #F56C6C">*</span><span style="padding-right: 12px;">工程地点</span>
          </div>
          <div class="editPCStyle">
            <el-form-item class="" prop="province">
              <el-select v-model="editFlowEntity.province" @change="changeProvinceInEdit"
                class="product_registration_selection">
                <el-option v-for="(item, index) in selection.provinces" :key="'provinces' + index" :value="item.id"
                  :label="item.name"></el-option>
              </el-select>
              <span style="margin: 0 10px">省/直辖市</span>
            </el-form-item>
            <el-form-item prop="city">
              <el-select v-model="editFlowEntity.city" class="product_registration_selection">
                <el-option v-for="(item, index) in editSelection.cities" :key="'cities' + index" :value="item.id"
                  :label="item.name"></el-option>
              </el-select>
              <span style="margin-left: 10px">市</span>
            </el-form-item>
          </div>
        </div>
        <!--详细地址-Logic展示-->
        <el-form-item v-if="setMealIsLogicInDialog" class="addressDetail"
          :class="{ noRequiredFlag: showProvinceCityInEdit }" style="width: 100%" label-width="7.5rem" :inline="false"
          :label="addrLabelInEdit">
          <el-input placeholder="请输入详细地址..." v-model="formForLogic.addressDetail" :disabled="true"
            style="width: 420px;"></el-input>
        </el-form-item>
        <!--详细地址-->
        <el-form-item v-else class="addressDetail" :class="{ noRequiredFlag: showProvinceCityInEdit }"
          style="width: 100%" label-width="7.5rem" :inline="false" :label="addrLabelInEdit" prop="addressDetail">
          <el-input placeholder="请输入详细地址..." v-model="editFlowEntity.addressDetail" :maxlength="200"
            style="width: 420px;"></el-input>
        </el-form-item>
        <!--备注-->
        <el-form-item class="activedCode transparentStar" style="width: 100%" label-width="7.5rem" :inline="false"
          label="备注" prop="remark">
          <el-input placeholder="请输入备注..." v-model="editFlowEntity.remark" :maxlength="200"
            style="width: 420px;"></el-input>
        </el-form-item>
        <!--序列号-单条-->
        <el-form-item v-if="setMealIsLogicInDialog" class="activedCode" style="width: 100%" label-width="7.5rem"
          :inline="false" label="序列号" prop="seriesNumberOnce"
          :rules="{ required: true, message: '序列号不能为空', trigger: 'blur' }">
          <el-input placeholder="请输入序列号..." v-model.trim="editFlowEntity.seriesNumberOnce" style="width: 420px;"
            @paste.native="(e) => handlePaste(e, 'single', {
              aimEntity: 'editFlowEntity',
              propertyName: 'seriesNumberOnce'
            })"></el-input>
        </el-form-item>
        <!--序列号-分页样式-->
        <el-form-item v-else class="activedCode moreWidth" style="width: 100%" label-width="7.5rem" :inline="false"
          label="序列号" prop="seriesNumber" :rules="[{ required: true, message: '请添加软件序列号', trigger: 'blur' },
          { validator: this.requiredSeriesNumber, trigger: ['blur', 'change'] }]">
          <!--按钮栏-->
          <div class="opeBar">
            <div class="btnForPub btnMr" @click="addRowInEdit()">添加</div>
            <div class="btnForPub btnMr" @click="patchDeleteInEdit()">批量删除</div>
            <!--todo 导入待做-->
            <!--<div class="btnForPub">导入</div>-->
          </div>
          <el-form :model="editFlowEntity" ref="dialogForm">
            <el-table :data="editFlowEntity.seriesNumber.slice((editPagination.currentPage - 1) * editPagination.pageSize,
              editPagination.currentPage * editPagination.pageSize)" @selection-change="handleSelectionChangeInEdit"
              class="flowTableClass" header-row-class-name="flowTableHeader" style="width: 100%" center stripe>
              <el-table-column type="selection" align="center" width="45">
              </el-table-column>
              <el-table-column label="序号" align="center" width="120">
                <template slot-scope="scope">{{ (editPagination.currentPage - 1) * editPagination.pageSize +
                  scope.$index +
                  1 }}</template>
              </el-table-column>
              <el-table-column label="激活码" align="center">
                <template slot-scope="scope">
                  <el-form-item class="relativeError"
                    :prop="'seriesNumber.' + ((editPagination.currentPage - 1) * editPagination.pageSize + scope.$index) + '.number'"
                    :rules="{ required: true, message: '激活码不能为空', trigger: 'blur' }">
                    <el-input
                      v-model.trim="editFlowEntity.seriesNumber[(editPagination.currentPage - 1) * editPagination.pageSize + scope.$index].number"
                      placeholder="请输入" @paste.native="(e) => handlePaste(e, 'multiple', {
                        aimEntity: 'editFlowEntity',
                        currentPage: editPagination.currentPage - 1,
                        pageSize: editPagination.pageSize,
                        index: scope.$index
                      })"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="120">
                <template slot-scope="scope">
                  <div
                    @click="reduceRowInEdit((editPagination.currentPage - 1) * editPagination.pageSize + scope.$index)"
                    class="opeBtn">删除</div>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination :pager-count="5" class="pagination" style="margin-top: 16px;text-align: center;"
              @size-change="handleSizeChangeInEdit" @current-change="handleCurrentChangeInEdit"
              :current-page="editPagination.currentPage" :page-sizes="[5, 10, 20, 50]"
              :page-size="editPagination.pageSize" layout="total, sizes, prev, pager, next, jumper"
              :total="editFlowEntity.seriesNumber.length">
            </el-pagination>
          </el-form>
        </el-form-item>
        <div style="text-align: right;">
          <div class="btnForPub btnMr" @click="closeEditDialog">取消</div>
          <div class="btnForPub btnMr" @click="beforeConfirmInDialog()">保存</div>
          <div class="btnForPub" @click="beforeConfirmInDialog(true)">提交申请</div>
        </div>
      </el-form>
    </el-dialog>
    <!--查看详情弹窗-->
    <el-dialog :visible="previewVisible" width="700px" @close="closePreviewDialog" @closed="resetPreviewApp"
      :close-on-click-modal="false">
      <div slot="title" class="dialogTitle">申请详情</div>
      <!--申请流程示意图-->
      <!--流程信息-->
      <div class="processInfo">
        <!--步骤条-->
        <div class="steps-conatiner" v-if="previewFlowItem.flowStatus !== 4" :style="{ height: stepHeight }">
          <el-steps direction="vertical" :active="activeStep" finish-status="success" :key="previewFlowItem.flowStatus">
            <template v-if="previewFlowItem.flowStatus === 6 || previewFlowItem.flowStatus === 1">
              <el-step></el-step>
              <el-step :icon="previewFlowItem.flowStatus === 1 ? 'el-icon-pie-chart' : ''"></el-step>
            </template>
            <template
              v-if="previewFlowItem.flowStatus === 5 || previewFlowItem.flowStatus === 2 || previewFlowItem.flowStatus === 0">
              <el-step></el-step>
              <el-step></el-step>
              <el-step :icon="previewFlowItem.flowStatus === 5 ? 'el-icon-pie-chart' : ''"></el-step>
            </template>
          </el-steps>
        </div>
        <div class="steps-content-container">
          <div class="steps-content">
            <div>
              <el-avatar icon="el-icon-s-custom" style="background-color: #20c997" :size="60"></el-avatar>
            </div>
            <div style="font-size: 16px;text-align: left;margin-left: 20px;">
              <div :title="sponsor" style="margin-bottom: 12px;margin-top: 2px;">
                {{ sponsor }}</div>
              <div style="color: #409EFF;" v-if="previewFlowItem.flowStatus !== 4">发起申请</div>
              <div style="color: #F56C6C;" v-else>已取消</div>
            </div>
            <!--时间-->
            <div class="step-time">{{ previewFlowItem.applicationTime }}</div>
          </div>
          <!--审批人-->
          <div v-if="previewFlowItem.flowStatus !== 4 && previewFlowItem.flowStatus === 6">
            <div class="steps-content-approver">
              <div style="display: flex;">
                <!--头像-->
                <div>
                  <el-avatar icon="el-icon-user-solid" style="background-color: #409EFF" :size="60"></el-avatar>
                </div>
                <!--简介-->
                <div style="font-size: 16px;text-align: left;margin-left: 20px;">
                  <div :title="previewFlowItem.reviewerName" style="margin-bottom: 12px;margin-top: 2px;">
                    {{ previewFlowItem.reviewerName }}
                  </div>
                  <div :style="{ color: '#F56C6C' }">
                    已会签驳回
                  </div>
                </div>
                <!--时间-->
                <div class="step-time">{{ previewFlowItem.reviewerTime }}</div>
              </div>
              <div v-if="previewFlowItem.flowRemark" style="font-size: 16px;text-align: left;padding-left: 80px;">
                审批意见：{{ previewFlowItem.flowRemark }}
              </div>
            </div>
          </div>
          <div v-if="previewFlowItem.flowStatus !== 4 && previewFlowItem.flowStatus === 1">
            <div class="steps-content-approver">
              <div style="display: flex;">
                <!--头像-->
                <div>
                  <el-avatar icon="el-icon-user-solid" style="background-color: #409EFF" :size="60"></el-avatar>
                </div>
                <!--简介-->
                <div style="font-size: 16px;text-align: left;margin-left: 20px;">
                  <div :title="previewFlowItem.userVos?.map(item => item.realName).join(', ')"
                    style="margin-bottom: 12px;margin-top: 2px;">
                    {{previewFlowItem.userVos?.map(item => item.realName).join(', ')}}
                  </div>
                  <div :style="{ color: '#E6A23C' }">
                    待会签
                  </div>
                </div>
                <!--时间-->
                <div class="step-time" style="color: orange;">已等待{{ detailTimer.hours }}小时{{ detailTimer.minutes }}分钟
                </div>
              </div>
            </div>
          </div>
          <div v-if="previewFlowItem.flowStatus !== 4 && previewFlowItem.flowStatus === 5">
            <div class="steps-content-approver">
              <div style="display: flex;">
                <!--头像-->
                <div>
                  <el-avatar icon="el-icon-user-solid" style="background-color: #409EFF" :size="60"></el-avatar>
                </div>
                <!--简介-->
                <div style="font-size: 16px;text-align: left;margin-left: 20px;">
                  <div :title="previewFlowItem.reviewerName" style="margin-bottom: 12px;margin-top: 2px;">
                    {{ previewFlowItem.reviewerName }}
                  </div>
                  <div :style="{ color: '#409EFF' }">
                    会签通过
                  </div>
                </div>
                <!--时间-->
                <div class="step-time">{{ previewFlowItem.reviewerTime }}</div>
              </div>
              <div v-if="previewFlowItem.flowRemark" style="font-size: 16px;text-align: left;padding-left: 80px;">
                审批意见：{{ previewFlowItem.flowRemark }}
              </div>
            </div>
            <div class="steps-content-approver">
              <div style="display: flex;">
                <!--头像-->
                <div>
                  <el-avatar icon="el-icon-user-solid" style="background-color: #409EFF" :size="60"></el-avatar>
                </div>
                <!--简介-->
                <div style="font-size: 16px;text-align: left;margin-left: 20px;">
                  <div :title="previewFlowItem.userVos?.map(item => item.realName).join(', ')"
                    style="margin-bottom: 12px;margin-top: 2px;">
                    {{previewFlowItem.userVos?.map(item => item.realName).join(', ')}}
                  </div>
                  <div :style="{ color: '#E6A23C' }">
                    待审核
                  </div>
                </div>
                <!--时间-->
                <div class="step-time" style="color: orange;">已等待{{ detailTimer.hours }}小时{{ detailTimer.minutes }}分钟
                </div>
              </div>
            </div>
          </div>
          <div v-if="previewFlowItem.flowStatus !== 4 && previewFlowItem.flowStatus === 2">
            <div class="steps-content-approver">
              <div style="display: flex;">
                <!--头像-->
                <div>
                  <el-avatar icon="el-icon-user-solid" style="background-color: #409EFF" :size="60"></el-avatar>
                </div>
                <!--简介-->
                <div style="font-size: 16px;text-align: left;margin-left: 20px;">
                  <div :title="previewFlowItem.reviewerName" style="margin-bottom: 12px;margin-top: 2px;">
                    {{ previewFlowItem.reviewerName }}
                  </div>
                  <div :style="{ color: '#409EFF' }">
                    会签通过
                  </div>
                </div>
                <!--时间-->
                <div class="step-time">{{ previewFlowItem.reviewerTime }}</div>
              </div>
              <div v-if="previewFlowItem.flowRemark" style="font-size: 16px;text-align: left;padding-left: 80px;">
                审批意见：{{ previewFlowItem.flowRemark }}
              </div>
            </div>
            <div class="steps-content-approver">
              <div style="display: flex;">
                <!--头像-->
                <div>
                  <el-avatar icon="el-icon-user-solid" style="background-color: #409EFF" :size="60"></el-avatar>
                </div>
                <!--简介-->
                <div style="font-size: 16px;text-align: left;margin-left: 20px;">
                  <div :title="previewFlowItem.approver" style="margin-bottom: 12px;margin-top: 2px;">
                    {{ previewFlowItem.approver }}
                  </div>
                  <div :style="{ color: '#409EFF' }">
                    审核通过
                  </div>
                </div>
                <!--时间-->
                <div class="step-time">{{ previewFlowItem.approvedTime }}</div>
              </div>
              <div v-if="previewFlowItem.flowRemark" style="font-size: 16px;text-align: left;padding-left: 80px;">
                审批意见：{{ previewFlowItem.flowRemark }}
              </div>
            </div>
          </div>
          <div v-if="previewFlowItem.flowStatus !== 4 && previewFlowItem.flowStatus === 0">
            <div class="steps-content-approver">
              <div style="display: flex;">
                <!--头像-->
                <div>
                  <el-avatar icon="el-icon-user-solid" style="background-color: #409EFF" :size="60"></el-avatar>
                </div>
                <!--简介-->
                <div style="font-size: 16px;text-align: left;margin-left: 20px;">
                  <div :title="previewFlowItem.reviewerName" style="margin-bottom: 12px;margin-top: 2px;">
                    {{ previewFlowItem.reviewerName }}
                  </div>
                  <div :style="{ color: '#409EFF' }">
                    会签通过
                  </div>
                </div>
                <!--时间-->
                <div class="step-time">{{ previewFlowItem.reviewerTime }}</div>
              </div>
              <div v-if="previewFlowItem.flowRemark" style="font-size: 16px;text-align: left;padding-left: 80px;">
                审批意见：{{ previewFlowItem.flowRemark }}
              </div>
            </div>
            <div class="steps-content-approver">
              <div style="display: flex;">
                <!--头像-->
                <div>
                  <el-avatar icon="el-icon-user-solid" style="background-color: #409EFF" :size="60"></el-avatar>
                </div>
                <!--简介-->
                <div style="font-size: 16px;text-align: left;margin-left: 20px;">
                  <div :title="previewFlowItem.approver" style="margin-bottom: 12px;margin-top: 2px;">
                    {{ previewFlowItem.approver }}
                  </div>
                  <div :style="{ color: '#F56C6C' }">
                    已审核驳回
                  </div>
                </div>
                <!--时间-->
                <div class="step-time">{{ previewFlowItem.approvedTime }}</div>
              </div>
              <div v-if="previewFlowItem.flowRemark" style="font-size: 16px;text-align: left;padding-left: 80px;">
                审批意见：{{ previewFlowItem.flowRemark }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--信息栏目-->
      <div>
        <div class="attrItem">
          <div class="attrTitle">产品类型</div>
          <div class="attrValue">{{ previewFlowItem.productTypeName }}</div>
        </div>
        <div class="attrItem">
          <div class="attrTitle">产品套餐/型号</div>
          <div class="attrValue">{{ previewFlowItem.productPackageName }}</div>
        </div>
        <!--<div class="attrItem">-->
        <!--  <div class="attrTitle">点位型号</div>-->
        <!--  <div class="attrValue">{{previewFlowItem.productPointType ? pointTypeOptions.find(item => item.value === previewFlowItem.productPointType).label : '/'}}</div>-->
        <!--</div>-->
        <div class="attrItem">
          <div class="attrTitle">销售类型</div>
          <div class="attrValue">{{ previewFlowItem.market == 1 ? '内销' : '出口' }}</div>
        </div>
        <div class="attrItem">
          <div class="attrTitle">订单编号</div>
          <div class="attrValue">{{ logicShow(previewFlowItem.orderNumber) }}</div>
        </div>
        <div class="attrItem">
          <div class="attrTitle">订单截图</div>
          <div class="attrValue">
            <template v-if="setMealIsLogicInShowDtl">/</template>
            <template v-else>
              <el-image v-if="previewFlowItem.orderImage" style="width: 110px; height: 110px"
                :src="previewFlowItem.orderImage" :preview-src-list="[previewFlowItem.orderImage]">
              </el-image>
              <div v-else>无</div>
            </template>
          </div>
        </div>
        <div class="attrItem">
          <div class="attrTitle">工程名称</div>
          <div class="attrValue">{{ logicShow(previewFlowItem.engineeringName) }}</div>
        </div>
        <!--<div class="attrItem">-->
        <!--  <div class="attrTitle">申请单位</div>-->
        <!--  <div class="attrValue">{{previewFlowItem.applicationOrganization}}</div>-->
        <!--</div>-->
        <div class="attrItem">
          <div class="attrTitle">工程地点</div>
          <div class="attrValue">
            <template v-if="setMealIsLogicInShowDtl">/</template>
            <template v-else>
              {{
                (previewFlowItem.province ? previewFlowItem.province : '')
                + (previewFlowItem.city ? previewFlowItem.city : '')
                + (previewFlowItem.engineeringAddress ? previewFlowItem.engineeringAddress : '')
              }}
            </template>
          </div>
        </div>
        <div class="attrItem">
          <div class="attrTitle">备注</div>
          <div class="attrValue">{{ previewFlowItem.remark }}</div>
        </div>
        <div v-if="previewFlowItem.productSerialNumber" style="max-height: 225px;overflow: auto;width: 530px;">
          <template v-for="(item, index) in previewFlowItem.productSerialNumber.split(' ')">
            <div class="attrItem" :key="'seriesNumberInDtl' + index">
              <div class="attrTitle">序列号{{ (index + 1) }}</div>
              <div class="attrValue">{{ item }}</div>
            </div>
          </template>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
import breadcrumb from '@/components/breadcrumb'
import city from '@/assets/json/city'
import province from '@/assets/json/province'
import { registerProduct, getRegisterByProposer, getLogicActiveNumber } from '../../../api/productRegistration'
import { mapGetters } from 'vuex'
import ProcessNode from '../../../components/processNode'
import { getProductSerialNumber } from '../../../utils/session'
import { batchPublish, deleteApp, uploadImage } from "../../../api/appStore/appPublish";
import { exportMethod2 } from '@/utils/fileExports';
import {
  getProductPackageList,
  getProductVoList,
  updateProductFlowStatus,
  registerProductNew,
  updateProduct,
  deleteProductRegister,
  downloadLicenses,
} from "../../../api/productActivate";

export default {
  name: "solution1",
  components: {
    breadcrumb,
    // ProcessNode
  },
  computed: {
    ...mapGetters(['getUserId', 'getUserName']),
    currentPageFlowData() {
      return this.flowTableData.slice((this.flowPagination.currentPage - 1) * this.flowPagination.pageSize, this.flowPagination.currentPage * this.flowPagination.pageSize)
    },
    registerResultTitle() {
      return this.registerResultCode === '100' ? '提交成功' : '提交失败';
    },
    registerResultContent() {
      return this.registerResultTips[this.registerResultCode] || '服务异常,请联系管理员！';
    },
    stepHeight() {
      if (this.previewFlowItem.flowStatus === 6 || this.previewFlowItem.flowStatus === 1) {
        return '152px';
      }
      return '280px';
    },
    activeStep() {
      // 步骤条更新步数
      if (this.previewFlowItem.flowStatus === 1) {
        return 1;
      } else if (this.previewFlowItem.flowStatus === 5 || this.previewFlowItem.flowStatus === 6) {
        return 2;
      } else if (this.previewFlowItem.flowStatus === 0 || this.previewFlowItem.flowStatus === 2) {
        return 3;
      }
    }
  },
  data() {
    return {
      detailTimer: {
        hours: 0,
        minutes: 0,
      },
      // 仅用于Logic展示的表单项，页面、弹窗共用
      formForLogic: {
        orderNumber: '/', // 订单编号
        belongToProject: '',  // 工程名称
        province: '', // 省
        city: '', // 市
        addressDetail: '',  // 详细地址
      },
      // 当前用户的手机号
      proposer: sessionStorage.getItem('userName'),
      // 需要单个展示的套餐名
      setMealNameForOnly: 'GMVisual Logic',
      // 表单页面套餐是否为Logic标志位，为false序列号展示表格，为true展示单条
      setMealIsLogicInPage: false,
      // 弹窗页面套餐是否为Logic标志位，为false序列号展示表格，为true展示单条
      setMealIsLogicInDialog: false,
      // 展示详情的弹窗页面，套餐是否为Logic标志位
      setMealIsLogicInShowDtl: false,
      // 流程管理的编辑弹窗标志位
      editVisible: false,
      // 编辑实体
      editFlowEntity: {
        productId: '',
        productType: '',
        productSetMeal: '',
        productPointType: '',
        salesType: '',
        belongToProject: '',
        // applicationUnit: '',
        province: '',
        city: '',
        addressDetail: '',
        orderNumber: '',
        orderImg: {
          imageUrl: '',
          imageUrlArr: [
            // {'url':'http://172.16.200.156:8088/apis/api/cafca97472454cd7b7651362832557b5.png'}
          ],  // 图片上传组件的绑定值需为list
        },
        remark: '',
        seriesNumber: [],
        // 序列号单条
        seriesNumberOnce: '',
      },
      // 省、市数据
      editSelection: {
        productTypes: [],
        productSetMeals: [],
        pointTypes: [],
        cities: [],
      },
      // 流程审批状态颜色
      approveStatusColor: {
        0: '#F56C6C',
        1: '#EA8713',
        2: '#67C23A',
      },
      // 流程记录详情显隐标志
      previewVisible: false,
      // 流程记录详情的实体
      previewFlowItem: {
      },
      // 发起申请人
      sponsor: '',
      // 是否禁用销售类型
      disabledSalesType: false,
      // 是否禁用销售类型-编辑
      disabledSalesTypeInEdit: false,
      // 点位类型选项
      pointTypeOptions: [
        { label: '小型工程（GBMS-MPC005U100）', value: 1 },
        { label: '中型工程（GBMS-MPC005U200）', value: 2 },
        { label: '大型工程（GBMS-MPC005U300）', value: 3 },
        { label: '超大型工程（GBMS-MPC005U400）', value: 4 },
      ],
      // 申请状态对应关系
      statusList: {
        0: '审核驳回',
        6: '会签驳回',
        1: '待会签',
        5: '待审核',
        2: '审核通过',
        4: '已取消',
      },
      statuss: [
        { value: 0, label: '审核驳回' },
        { value: 6, label: '会签驳回' },
        { value: 5, label: '待审核' },
        { value: 1, label: '待会签' },
        { value: 2, label: '审核通过' },
        { value: 4, label: '已取消' },
      ],
      // 文本输入框自适应内容高度
      autoSize: {
        minRows: 2,
        maxRows: 2
      },
      // 是否展示点位型号选项
      showPointTypeItem: false,
      // 是否展示点位型号选项-编辑
      showPointTypeItemInEdit: false,
      flowPagination: {
        currentPage: 1,
        pageSize: 10,
        jumpPage: 1
      },
      flowTableData: [],
      // 当前分页
      showRegister: true,
      guide: [
        // {label: '格力绿控网'},
        { label: '服务与支持' },
        { label: '产品激活' },
      ],

      labelPosition: "left",
      form: {
        // 产品类型
        productType: '',
        // 产品套餐/型号
        productSetMeal: '',
        // 点位型号
        productPointType: '',
        // 销售类型
        salesType: 1,
        // 工程名称
        belongToProject: '',
        // 申请单位
        // applicationUnit: '',
        // 省
        province: '',
        // 市
        city: '',
        // 详细地址
        addressDetail: '',
        // 订单编号
        orderNumber: '',
        // 订单截图
        orderImg: {
          imageUrl: '',
          imageUrlArr: [
            // {'url':'http://172.16.200.156:8088/apis/api/cafca97472454cd7b7651362832557b5.png'}
          ],  // 图片上传组件的绑定值需为list
        },
        // 备注
        remark: '',
        // 软件激活码
        activeCode: getProductSerialNumber(),
        // 序列号
        seriesNumber: [],
        // 序列号单条
        seriesNumberOnce: '',
      },

      imgPreviewVisible: false, // 预览图片弹窗
      imgPreviewVisibleInEdit: false, // 预览图片弹窗-编辑

      rules: {
        province: [
          {
            trigger: 'change', required: true, message: '请选择省份'
          },
        ],
        city: [
          {
            trigger: 'change', required: true, message: '请选择城市'
          },
        ],
        productType: [
          {
            trigger: 'change', required: true, message: '请选择产品类型'
          },
        ],
        productSetMeal: [
          {
            trigger: 'change', required: true, message: '请选择产品套餐/型号'
          },
        ],
        productPointType: [
          {
            trigger: 'change', required: true, message: '请选择点位型号'
          }
        ],
        belongToProject: [
          // { trigger: 'blur', required: true, message: '请输入工程名称' },
          { validator: this.charsLimit, trigger: ['blur', 'change'], required: true }
        ],
        // applicationUnit: [
        //   { trigger: 'blur', required: true, message: '请输入申请单位' },
        //   { validator: this.charsLimit, trigger: ['blur','change'] }
        // ],
        addressDetail: [
          {
            trigger: 'blur', required: true, message: '请输入详细地址'
          },
        ],
        activeCode: [
          {
            trigger: 'blur', required: true, message: '请输入软件序列号'
          },
        ],
        salesType: [
          {
            trigger: 'change', required: true, message: '请选择销售类型'
          },
        ],
        orderNumber: [
          {
            validator: (rule, value, callback) => {
              let reg1 = /^[\u4e00-\u9fa5]+(SF)?\d{2}\d{3,4}$/; // 中文开头的编号
              let reg2 = /^[A-Za-z]+(SF)?\d{2}(0[0-9]|1[0-2])\d{4}$/; // 英文开头的编号
              if (value === '') {
                callback(new Error('请输入订单编号'))
              } else if (!reg1.test(value) && !reg2.test(value)) {
                callback(new Error('请填写正确的订单编号'))
              }
            }, trigger: 'blur', required: true,
          },
        ],
        orderImg: [
          // {
          //   trigger: 'change', required: true, message: '请输入订单编号'
          // },
        ],
      },
      // 省、市数据
      selection: {
        cities: [],
        provinces: [],
        productTypes: [],
        productSetMeals: [],
        pointTypes: [],
        salesTypes: [
          { label: '内销', value: 1 },
          { label: '出口', value: 2 },
        ],
      },
      // 内销、出口类型对应关系
      salesTypeMap: {
        local: [
          'GBM-IP100',
          'GBM-IP101',
          'GBM-IP110',
          'GBM-SR100',
          'GBM-DDC100',
          'GBM-DDC110',
          'MC20001490',
          'FC30-24/DF（B）',
        ],
        abroad: [
          'GBM-IP100E',
          'GBM-DDC100E',
          'MC20001850',
          'FE30-24/DF（B）',
        ]
      },
      typeCache: {
        1: 'GMLink可编程网络控制引擎',
        2: 'GreeBlock组态编程软件',
        3: '空调智慧管理系统'
      },
      successRegister: false,
      registerResultTips: {
        '100': '已成功提交验证，请耐心等待管理员审核，谢谢！',
        '536': '该序列号已在服务端排队审核,请耐心等待审核！',
        '537': '序列号不正确！',
        '538': '服务异常,请检测参数格式是否正确！',
        '539': '服务异常,请联系管理员！',
      },
      registerResultCode: '100',

      // 详细地址label
      addrLabel: ' ',
      // 省市显隐标识符
      showProvinceCity: true,
      // 详细地址label-编辑
      addrLabelInEdit: ' ',
      // 省市显隐标识符-编辑
      showProvinceCityInEdit: true,

      // 激活码表格相关
      // 序列号表格勾选项集合
      idsArr: [],
      // 序列号表格勾选项集合-编辑
      idsArrInEdit: [],
      // 分页器
      seriesNumberPagination: {
        currentPage: 1,
        pageSize: 10
      },
      // 分页器-编辑
      editPagination: {
        currentPage: 1,
        pageSize: 10
      },
      // 流程管理搜索条件
      search: {
        productType: '',
        productSetMeal: '',
        timeRange: '',
        flowStatus: '',
        keyWords: '',
        // 分页器
        currentPage: 1,
        pageSize: 15,
        total: 0,
        productTypes: [],
        productSetMeals: [],
      },
      // 流程管理数据源
      flowMngTableData: [],
    }
  },
  methods: {
    // 计算等待时间
    calWaitTime(applyTime) {
      let stime = new Date(applyTime).getTime();
      let etime = new Date().getTime();
      let usetime = etime - stime;

      let h = Math.floor(usetime / (3600 * 1000));
      let leave = usetime % (3600 * 1000);
      let min = Math.floor(leave / (60 * 1000));

      this.detailTimer.hours = h;
      this.detailTimer.minutes = min;
      this.startInterval();
    },
    /**
     * @Description: 关闭定时器
     * @author Li Yanjie
     * @date 2020/7/16
     */
    closeInterval() {
      if (this.intervalTimer) {
        clearInterval(this.intervalTimer);
        this.intervalTimer = null;
      }
    },

    /**
     * @Description: 开始定时器，倒计时计算等待时间
     * @author Li Yanjie
     * @date 2020/7/16
     */
    startInterval() {
      this.closeInterval();
      this.intervalTimer = setInterval(() => {
        this.detailTimer.minutes++;
        if (this.detailTimer.minutes >= 60) {
          this.detailTimer.hours++;
          this.detailTimer.minutes = 0;
        }
      }, 60000)
    },
    beforeRouteLeave(to, from, next) {
      this.closeInterval();
      next();
    },
    beforeDestroy() {
      this.closeInterval();
    },
    // 处理粘贴激活码方法
    handlePaste(event, sourceType, aimData) {
      console.log('123')
      // 1. 阻止默认粘贴行为
      event.preventDefault();

      // 2. 读取剪贴板原始数据
      const clipboardData = event.clipboardData || window.clipboardData;
      const rawText = clipboardData.getData('text');

      console.log(rawText, rawText.length, '处理前')
      // 3. 执行数据清理
      const cleanedValue = this.cleanSpecialSpaces(rawText);
      console.log(cleanedValue, cleanedValue.length, '处理后')

      // 4. 手动更新数据
      if (sourceType === 'multiple') {
        this.$set(this[aimData.aimEntity].seriesNumber[aimData.currentPage * aimData.pageSize + aimData.index], 'number', cleanedValue);
      } else if (sourceType === 'single') {
        this.$set(this[aimData.aimEntity], aimData.propertyName, cleanedValue);
      }

      // 5. 同步更新输入框显示
      this.$nextTick(() => {
        event.target.value = cleanedValue;
      });
    },
    // 处理异常字符的方法
    cleanSpecialSpaces(value) {
      // 匹配所有空白字符：空格、制表符、换行、全角空格等
      // return value.replace(/[\s\u3000\t\n\r]/g, '');
      // 匹配所有空白符、零宽空格、字节顺序标记等
      const invisibleCharsRegex = /^[\s\uFEFF\xA0\u200B-\u200D\u2060\u2028\u2029]+|[\s\uFEFF\xA0\u200B-\u200D\u2060\u2028\u2029]+$/g;
      return value.replace(invisibleCharsRegex, '');
    },
    // 套餐为GMVisual Logic的特殊展示
    logicShow(value) {
      return this.setMealIsLogicInShowDtl ? '/' : value;
    },
    // 判断当前用户激活logic次数，给出相应提示
    async checkUserActiveLogic() {
      let res = await getLogicActiveNumber({ proposer: this.proposer });
      if (res.returnCode === '100') {
        return res.returnData;  // 返回激活logic次数
      }
      return 2; // 默认返回一个大于1的次数避免多次申请
    },
    // 判断表单页面套餐是否为Logic，从而决定序列号的展示方式
    checkSetMealIsLogicInPage() {
      let setMealCheckName = this.selection.productSetMeals.filter(item => item.id === this.form.productSetMeal)[0]?.name ?? '';
      this.setMealIsLogicInPage = setMealCheckName === this.setMealNameForOnly;
      if (this.setMealIsLogicInPage) {
        this.$set(this.form, 'seriesNumber', []);
        this.addRow();
        this.$refs['productForm'].clearValidate();
      } else {
        this.$set(this.form, 'seriesNumberOnce', '');
      }
    },
    // 判断表单弹窗套餐是否为Logic，从而决定序列号的展示方式
    checkSetMealIsLogicInDialog() {
      let setMealCheckName = this.editSelection.productSetMeals.filter(item => item.id === this.editFlowEntity.productSetMeal)[0]?.name ?? '';
      this.setMealIsLogicInDialog = setMealCheckName === this.setMealNameForOnly;
      if (this.setMealIsLogicInDialog) {
        this.$set(this.editFlowEntity, 'seriesNumber', []);
        this.addRowInEdit();
      } else {
        this.$set(this.editFlowEntity, 'seriesNumberOnce', '');
      }
    },
    // 提交申请，保存＋提交
    async applyInEdit(push = false) {
      let activeCodeHasEmpty = false;
      if (!this.setMealIsLogicInDialog) { // 使用了表格式的序列号才进行校验
        activeCodeHasEmpty = this.searchEmptyActiveCodeInDialog();
        if (activeCodeHasEmpty) {
          this.$nextTick(() => {
            this.$refs['dialogForm'].validate((valid) => {
              if (valid) {
              } else {
                // return false;
              }
            });
          })
        }
      }
      let error1 = false;
      this.$refs['applyForm'].validate((valid) => {
        if (valid) {
        } else {
          error1 = true;
          // return false;
        }
      });
      if (error1 || activeCodeHasEmpty) {
        return;
      }
      let seriesNumberArr = [];
      for (let item of this.editFlowEntity.seriesNumber) {
        seriesNumberArr.push(item.number);
      }
      let data = {
        productId: this.editFlowEntity.productId,
        productType: this.editFlowEntity.productType,
        productPackage: this.editFlowEntity.productSetMeal,
        productPointType: this.editFlowEntity.productPointType,
        market: this.editFlowEntity.salesType,
        engineeringName: this.editFlowEntity.belongToProject,
        engineeringAddress: this.editFlowEntity.addressDetail,
        orderNumber: this.editFlowEntity.orderNumber,
        orderImage: this.editFlowEntity.orderImg.imageUrl,  // 非必填
        productSerialNumber: seriesNumberArr.join(' '),
        proposer: this.proposer,
        // applicationOrganization: this.editFlowEntity.applicationUnit,
        remark: this.editFlowEntity.remark,
      };
      data.productSerialNumber = this.setMealIsLogicInDialog ? this.editFlowEntity.seriesNumberOnce : seriesNumberArr.join(' ');
      // 内销才有省市
      if (this.editFlowEntity.salesType === 1 && !this.setMealIsLogicInDialog) {
        let cityName = '';
        let provinceName = '';
        if (this.editFlowEntity.province) {
          cityName = city[this.editFlowEntity.province]?.find(item => item.id === this.editFlowEntity.city).name ?? '';
          provinceName = province?.find(item => item.id === this.editFlowEntity.province).name ?? '';
          data.province = provinceName;
          data.city = cityName;
        }
      }
      // GMVisual Logic申请时，禁用项全部置为空
      if (this.setMealIsLogicInDialog) {
        data.orderNumber = '';
        data.orderImage = '';
        data.engineeringName = '';
        data.province = '';
        data.city = '';
        data.engineeringAddress = '';
      }

      let res1 = await updateProduct(data);
      let res2;
      if (push) {
        res2 = await updateProductFlowStatus({
          flowStatus: 1,
          productId: this.editFlowEntity.productId
        });
      }
      if (res1.returnCode === '100' && res2 ? res2.returnCode === '100' : true) {
        if (!push) {
          // 给出成功提示弹窗
          this.$msg('保存成功', 'success');
        }
        this.closeEditDialog();
        this.searchData();
      }
    },
    // 保存更改
    saveFlow() {
      let activeCodeHasEmpty = false;
      if (!this.setMealIsLogicInDialog) {
        activeCodeHasEmpty = this.searchEmptyActiveCodeInDialog();
        if (activeCodeHasEmpty) {
          this.$nextTick(() => {
            this.$refs['dialogForm'].validate((valid) => {
              if (valid) {
              } else {
                // return false;
              }
            });
          })
        }
      }
      let error1 = false;
      this.$refs['applyForm'].validate((valid) => {
        if (valid) {
        } else {
          error1 = true;
          // return false;
        }
      });
      if (error1 || activeCodeHasEmpty) {
        return;
      }
      let seriesNumberArr = [];
      for (let item of this.editFlowEntity.seriesNumber) {
        seriesNumberArr.push(item.number);
      }
      let data = {
        productId: this.editFlowEntity.productId,
        productType: this.editFlowEntity.productType,
        productPackage: this.editFlowEntity.productSetMeal,
        productPointType: this.editFlowEntity.productPointType,
        market: this.editFlowEntity.salesType,
        engineeringName: this.editFlowEntity.belongToProject,
        engineeringAddress: this.editFlowEntity.addressDetail,
        orderNumber: this.editFlowEntity.orderNumber,
        orderImage: this.editFlowEntity.orderImg.imageUrl,  // 非必填
        proposer: this.proposer,
        // applicationOrganization: this.editFlowEntity.applicationUnit,
        remark: this.editFlowEntity.remark,
      };
      data.productSerialNumber = this.setMealIsLogicInDialog ? this.editFlowEntity.seriesNumberOnce : seriesNumberArr.join(' ');
      // 内销才有省市
      if (this.editFlowEntity.salesType === 1 && !this.setMealIsLogicInDialog) {
        let cityName = '';
        let provinceName = '';
        cityName = city[this.editFlowEntity.province].find(item => item.id === this.editFlowEntity.city).name;
        provinceName = province.find(item => item.id === this.editFlowEntity.province).name;
        data.province = provinceName;
        data.city = cityName;
      }
      // GMVisual Logic申请时，禁用项全部置为空
      if (this.setMealIsLogicInDialog) {
        data.orderNumber = '';
        data.orderImage = '';
        data.engineeringName = '';
        data.province = '';
        data.city = '';
        data.engineeringAddress = '';
      }
      updateProduct(data).then(res => {
        // 给出成功提示弹窗
        this.$msg('保存成功', 'success');
        this.closeEditDialog();
        this.searchData();
      }).catch(e => {

      })
    },
    // 关闭编辑弹窗
    closeEditDialog() {
      if (this.$refs.applyForm) {
        this.$refs.applyForm.clearValidate();
        // this.resetAppDtl();
      }
      this.editFlowEntity = {
        productId: '',
        productType: '',
        productSetMeal: '',
        productPointType: '',
        salesType: '',
        belongToProject: '',
        // applicationUnit: '',
        province: '',
        city: '',
        addressDetail: '',
        orderNumber: '',
        orderImg: {
          imageUrl: '',
          imageUrlArr: [
            // {'url':'http://172.16.200.156:8088/apis/ai/cafca97472454cd7b7651362832557b5.png'}
          ],  // 图片上传组件的绑定值需为list
        },
        remark: '',
        seriesNumber: [],
        seriesNumberOnce: '',
      };
      // this.appDtl.appImg.imageUrlArr = [];  // 清空图片列表
      // this.appDtl.appArr = [];  // 清空上传文件的列表
      this.editVisible = false;
    },
    // 关闭查看详情弹窗
    closePreviewDialog() {
      this.previewVisible = false;

    },
    // 重置查看详情的实体
    resetPreviewApp() {
      // this.previewFlowItem = {};
      this.sponsor = '';
    },
    // 获取申请提交记录
    getApplyRecordTable() {
      let data = {
        proposer: this.proposer,
        pageNo: this.search.currentPage,
        pageSize: this.search.pageSize,
      };
      if (this.search.productType) {
        data.productType = this.search.productType;
      }
      if (this.search.productSetMeal) {
        data.productPackage = this.search.productSetMeal;
      }
      // if (this.search.timeRange) {  // todo 时间可能要改格式
      //   data.applicationBeginTime = this.search.timeRange[0];
      //   data.applicationEndTime = this.search.timeRange[1];
      // }
      if (this.search.flowStatus || this.search.flowStatus === 0) {
        data.flowStatus = this.search.flowStatus;
      }
      if (this.search.keyWords) {
        data.keyWord = this.search.keyWords;
      }
      getProductVoList(data).then(res => {
        if (res.returnCode === '100') {
          this.flowMngTableData = res.returnData.productVoList;
          this.search.total = res.returnData.count;
        }
      }).catch(e => e);
    },
    // 根据id找到label
    findOptionLabelById(id, type, dataSource) {
      if (type == 'productType') {
        for (let item of this[dataSource].productTypes) {
          if (item.productTypeId == id) {
            return item.productTypeName;
          }
        }
      } else if (type == 'productSetMeal') {
        for (let item of this[dataSource].productSetMeals) {
          if (item.id == id) {
            return item.name;
          }
        }
      }
      return '';
    },
    // 更改产品类型-申请记录
    changeProductTypeInRecord() {
      this.search.productSetMeal = '';
      let aimDataSource = this.selection.productTypes.filter(item => item.productTypeId == this.search.productType);
      this.search.productSetMeals = aimDataSource[0] ? aimDataSource[0].productPackageList : [];
      this.searchData();
    },
    // 更改产品类型
    changeProductType() {
      this.form.productSetMeal = '';
      this.setMealIsLogicInPage = false;
      // this.form.salesType = '';
      this.disabledSalesType = false;
      this.showPointTypeItem = false;
      let aimDataSource = this.selection.productTypes.filter(item => item.productTypeId == this.form.productType);
      this.selection.productSetMeals = aimDataSource[0] ? aimDataSource[0].productPackageList : [];
    },
    // 更改产品类型-编辑
    changeProductTypeInEdit() {
      this.editFlowEntity.productSetMeal = '';
      // this.editFlowEntity.salesType = '';
      this.disabledSalesTypeInEdit = false;
      this.showPointTypeItemInEdit = false;
      let aimDataSource = this.editSelection.productTypes.filter(item => item.productTypeId == this.editFlowEntity.productType);
      this.editSelection.productSetMeals = aimDataSource[0] ? aimDataSource[0].productPackageList : [];
    },
    // 更改产品套餐/型号
    changeProductSetMeal() {
      this.checkSetMealIsLogicInPage();

      let selectProductType = this.findOptionLabelById(this.form.productType, 'productType', 'selection');
      let selectProductSetMeal = this.findOptionLabelById(this.form.productSetMeal, 'productSetMeal', 'selection');
      // 点位类型相关逻辑
      this.showPointTypeItem = this.form.productType === 2
        && this.form.productSetMeal !== 9;
      // this.showPointTypeItem = selectProductType === 'GMVisual图形化平台'
      //   && selectProductSetMeal !== 'GMVisual Logic';
      this.form.productPointType = '';
      this.selection.pointTypes = this.pointTypeOptions;

      // 销售类型限制逻辑
      // if (this.salesTypeMap.local.includes(selectProductSetMeal)) {
      //   this.form.salesType = 1;
      //   this.disabledSalesType = true;
      //   this.changeAddrOPE(this.form.salesType);
      // } else if (this.salesTypeMap.abroad.includes(selectProductSetMeal)) {
      //   this.form.salesType = 2;
      //   this.disabledSalesType = true;
      //   this.changeAddrOPE(this.form.salesType);
      // } else {
      //   this.form.salesType = '';
      //   this.disabledSalesType = false;
      // }
    },
    // 更改产品套餐/型号-编辑
    changeProductSetMealInEdit() {
      let selectProductType = this.findOptionLabelById(this.editFlowEntity.productType, 'productType', 'editSelection');
      let selectProductSetMeal = this.findOptionLabelById(this.editFlowEntity.productSetMeal, 'productSetMeal', 'editSelection');
      // 点位类型相关逻辑
      this.showPointTypeItemInEdit = this.editFlowEntity.productType === 2
        && this.editFlowEntity.productSetMeal !== 9;
      // this.showPointTypeItemInEdit = selectProductType === 'GMVisual图形化平台'
      //   && selectProductSetMeal !== 'GMVisual Logic';
      this.editFlowEntity.productPointType = '';
      this.editSelection.pointTypes = this.pointTypeOptions;

      this.checkSetMealIsLogicInDialog();  // 根据所选套餐判断序列号展示为表格还是单条
      // 销售类型限制逻辑
      // if (this.salesTypeMap.local.includes(selectProductSetMeal)) {
      //   this.editFlowEntity.salesType = 1;
      //   this.disabledSalesTypeInEdit = true;
      //   this.changeAddrOPEInEdit(this.editFlowEntity.salesType);
      // } else if (this.salesTypeMap.abroad.includes(selectProductSetMeal)) {
      //   this.editFlowEntity.salesType = 2;
      //   this.disabledSalesTypeInEdit = true;
      //   this.changeAddrOPEInEdit(this.editFlowEntity.salesType);
      // } else {
      //   this.editFlowEntity.salesType = '';
      //   this.disabledSalesTypeInEdit = false;
      // }
    },
    // 初始化产品类型选项
    initProductOption() {
      getProductPackageList().then(res => {
        if (res.returnCode == '100') {
          this.selection.productTypes = res.returnData;
          this.search.productTypes = res.returnData;
        }
      }).catch(e => e);
    },
    //=========================流程管理相关的=========================
    // 流程管理数据查询
    searchData() {
      this.search.currentPage = 1;
      this.search.pageSize = 15;
      this.getApplyRecordTable();
    },
    searchCurrentPageChange(val) {
      this.search.currentPage = val;
      this.getApplyRecordTable();
    },
    searchPageSizeChange(val) {
      this.search.currentPage = 1;
      this.search.pageSize = val;
      this.getApplyRecordTable();
    },
    // 根据状态判断按钮是否启用
    btnCanUse(statusName, btnName) {
      let bool;
      switch (btnName) {
        case '取消':
          bool = (statusName === '待会签' || statusName === '待审核');
          break;
        case '提交':
        case '详情':
          bool = true;
          break;
        case '编辑':
          bool = !statusName.includes('待');
          break;
        case '删除':
          bool = ['待会签', '已取消', '待审核'].includes(statusName);
          break;
      }
      return bool;
    },
    downloadCertificate(scope) {
      // downloadLicenses({productId: scope.row.productId}).then(res => {
      // }).catch(e => e);
      let myObj = {
        method: 'get',
        url: 'api/product/downloadLicenses',
        params: qs.stringify({
          productId: scope.row.productId
        })
      };
      exportMethod2(myObj);
    },
    clickCancel(scope) {
      if (this.btnCanUse(this.statusList[scope.row.flowStatus], '取消')) {
        this.$confirm('请确认是否取消该申请', '取消确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          updateProductFlowStatus({
            flowStatus: 4,
            productId: scope.row.productId
          }).then(res => {
            if (res.returnCode === '100') {
              this.searchData();
            }
          }).catch(e => e)
        }).catch(e => e)
      }
    },
    clickConfirm(scope) {
      if (this.btnCanUse(this.statusList[scope.row.flowStatus], '提交')) {
        // this.$del({ title: '提交确认', msg: '请确认是否提交该申请' }).then(() => {
        updateProductFlowStatus({
          flowStatus: 1,
          productId: scope.row.productId
        }).then(res => {
          if (res.returnCode === '100') {
            this.searchData();
          }
        }).catch(e => e)
        // }).catch(e => e)
      }
    },
    clickShowDtl(scope) {
      if (this.btnCanUse(this.statusList[scope.row.flowStatus], '详情')) {
        this.previewFlowItem = scope.row;
        this.setMealIsLogicInShowDtl = scope.row?.productPackageName === this.setMealNameForOnly;
        this.sponsor = sessionStorage.getItem('realName');
        if (this.previewFlowItem.flowStatus === 1) {
          if (this.previewFlowItem.applicationTime) {
            this.calWaitTime(this.previewFlowItem.applicationTime);
          }
        } else if (this.previewFlowItem.flowStatus === 5) {
          if (this.previewFlowItem.reviewerTime) {
            this.calWaitTime(this.previewFlowItem.reviewerTime);
          }
        }
        this.previewVisible = true;
      }
    },
    clickEdit(scope) {
      if (this.btnCanUse(this.statusList[scope.row.flowStatus], '编辑')) {
        this.$nextTick(() => {
          this.editVisible = true;
          this.editFlowEntity.productId = scope.row.productId;
          this.editSelection.productTypes = JSON.parse(JSON.stringify(this.selection.productTypes));
          this.editFlowEntity.productType = scope.row.productType;
          this.changeProductTypeInEdit(); // 选择产品类型的逻辑
          this.editFlowEntity.productSetMeal = scope.row.productPackage;
          this.changeProductSetMealInEdit();  // 选择产品套餐的逻辑
          if (scope.row.productPointType) {
            this.editFlowEntity.productPointType = scope.row.productPointType;
          }
          this.editFlowEntity.salesType = scope.row.market;
          this.changeAddrOPEInEdit(this.editFlowEntity.salesType);  // 选择进出口对地址的逻辑
          this.editFlowEntity.belongToProject = scope.row.engineeringName;
          // this.editFlowEntity.applicationUnit = scope.row.applicationOrganization;
          if (scope.row.market === 1 && !this.setMealIsLogicInDialog) {
            this.editFlowEntity.province = this.selection.provinces?.find(item => item.name === scope.row.province)?.id;
            this.changeProvinceInEdit(this.editFlowEntity.province);  // 选择省份的逻辑
            this.editFlowEntity.city = this.editSelection.cities?.find(item => item.name === scope.row.city)?.id;
          }
          this.editFlowEntity.addressDetail = scope.row.engineeringAddress;
          this.editFlowEntity.orderNumber = scope.row.orderNumber;
          if (scope.row.orderImage) {
            this.editFlowEntity.orderImg = {
              imageUrl: scope.row.orderImage,
              imageUrlArr: [{ 'url': scope.row.orderImage }],
            }
          }
          this.editFlowEntity.remark = scope.row.remark;
          // 序列号赋值
          if (this.setMealIsLogicInDialog) {  // 单条
            this.$set(this.editFlowEntity, 'seriesNumberOnce', scope.row.productSerialNumber);
          } else {  // 表格
            let serialNumberArr = scope.row.productSerialNumber.split(' ');
            for (let i in serialNumberArr) {
              this.editFlowEntity.seriesNumber.push({ number: '', id: 'editNumber' + new Date().getTime() });
            }

            this.$nextTick(() => {
              for (let i in serialNumberArr) {
                this.$set(this.editFlowEntity.seriesNumber[i], 'number', serialNumberArr[i]);
              }
            })
          }
        })
      }
    },
    clickDelete(scope) {
      if (this.btnCanUse(this.statusList[scope.row.flowStatus], '删除')) {
        // 新的删除实现
        this.$confirm('请确认是否删除该申请', '删除确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 删除末页唯一一条数据时，当前页要往前跳一页，否则搜不出数据
          if (this.search.currentPage > 1) {
            let maxPage = Math.ceil(this.search.total / this.search.pageSize)
            if (this.search.currentPage === maxPage && this.tableData.length === 1) {
              this.search.currentPage -= 1
            }
          }

          deleteProductRegister({ productId: scope.row.productId }).then(res => {
            this.$msg('删除成功', 'success')
            this.searchData();
          }).catch(e => e)
        }).catch(() => { });
        // 旧的删除实现
        // this.$del({ title: '', msg: '请确认是否删除该申请' }).then(() => {
        //   // 删除末页唯一一条数据时，当前页要往前跳一页，否则搜不出数据
        //   if (this.search.currentPage > 1) {
        //     let maxPage = Math.ceil(this.search.total / this.search.pageSize)
        //     if (this.search.currentPage === maxPage && this.tableData.length === 1) {
        //       this.search.currentPage -= 1
        //     }
        //   }
        //
        //   deleteProductRegister({productId: scope.row.productId}).then(res => {
        //     this.$msg('删除成功', 'success')
        //     this.searchData();
        //   }).catch(e => e)
        // }).catch(e => e)
      }
    },
    //=========================流程管理相关的=========================

    // 输入字符限制
    charsLimit(rule, value, callback) {
      if (value) {
        let reg = /^[a-zA-Z\u4e00-\u9fa50-9_/#'-]+$/;
        if (!reg.test(value)) {
          callback(new Error('仅支持输入英文字母、中文、数字、下划线、斜线、#、\'、-组合的字符'));
        }
        callback();
      } else {
        callback(new Error('请输入工程名称'));
      }
    },
    // 序列号限制
    requiredSeriesNumber(rule, value, callback) {
      // 外层form对里层序列号的校验，暂时不用，关闭掉
      callback();
      return;
      let hasEmpty = false;
      if (Array.isArray(value)) {
        for (let item of value) {
          if (!item.number) {
            hasEmpty = true;
            break;
          }
        }
        if (hasEmpty) {
          callback(new Error('激活码不能为空'));
        } else {
          callback();
        }
      }
      callback();
    },
    // 分页器操作
    handleCurrentChange(val) {
      this.seriesNumberPagination.currentPage = val;
      if (this.$refs['regForm']) {
        this.$refs['regForm'].clearValidate();
      }
    },
    handleSizeChange(val) {
      this.seriesNumberPagination.pageSize = val;
      if (this.$refs['regForm']) {
        this.$refs['regForm'].clearValidate();
      }
    },
    // 分页器操作
    handleCurrentChangeInEdit(val) {
      this.editPagination.currentPage = val;
      if (this.$refs['dialogForm']) {
        this.$refs['dialogForm'].clearValidate();
      }
    },
    handleSizeChangeInEdit(val) {
      this.editPagination.pageSize = val;
      if (this.$refs['dialogForm']) {
        this.$refs['dialogForm'].clearValidate();
      }
    },
    // 表格勾选框改变
    handleSelectionChange(val) {
      let idsArr = [];
      for (let i = 0; i < val.length; i++) {
        idsArr.push(val[i].id);
      }
      this.idsArr = idsArr;
    },
    // 表格勾选框改变-编辑
    handleSelectionChangeInEdit(val) {
      let idsArr = [];
      for (let i = 0; i < val.length; i++) {
        idsArr.push(val[i].id);
      }
      this.idsArrInEdit = idsArr;
    },
    // 增加一行序列号
    addRow() {
      if (this.form.seriesNumber.length >= 200) {
        this.$msg('单次申请序列号上限为200个', 'warning');
        return;
      }
      this.form.seriesNumber.push({ number: '', id: 'number' + new Date().getTime() });
      // 跳转至新增的页面
      this.seriesNumberPagination.currentPage = this.form.seriesNumber.length > this.seriesNumberPagination.pageSize
        ? Math.ceil(this.form.seriesNumber.length / this.seriesNumberPagination.pageSize)
        : 1;
    },
    // 增加一行序列号-编辑
    addRowInEdit() {
      if (this.editFlowEntity.seriesNumber.length >= 200) {
        this.$msg('单次申请序列号上限为200个', 'warning');
        return;
      }
      this.editFlowEntity.seriesNumber.push({ number: '', id: 'editNumber' + new Date().getTime() });
      // 跳转至新增的页面
      this.editPagination.currentPage = this.editFlowEntity.seriesNumber.length > this.editPagination.pageSize
        ? Math.ceil(this.editFlowEntity.seriesNumber.length / this.editPagination.pageSize)
        : 1;
    },
    // 减少一行序列号
    reduceRow(index) {
      let aimCurrentPage = this.seriesNumberPagination.currentPage;
      // 删除末页唯一一条数据时，当前页要往前跳一页，否则搜不出数据
      if (this.seriesNumberPagination.currentPage > 1) {
        let maxPage = Math.ceil(this.form.seriesNumber.length / this.seriesNumberPagination.pageSize);
        if (this.seriesNumberPagination.currentPage === maxPage && this.form.seriesNumber.length % this.seriesNumberPagination.pageSize === 1) {
          aimCurrentPage -= 1;
        }
      }
      // 删除操作
      this.form.seriesNumber.splice(index, 1);
      this.seriesNumberPagination.currentPage = aimCurrentPage;
    },
    // 减少一行序列号-编辑
    reduceRowInEdit(index) {
      let aimCurrentPage = this.editPagination.currentPage;
      // 删除末页唯一一条数据时，当前页要往前跳一页，否则搜不出数据
      if (this.editPagination.currentPage > 1) {
        let maxPage = Math.ceil(this.editFlowEntity.seriesNumber.length / this.editPagination.pageSize);
        if (this.editPagination.currentPage === maxPage && this.editFlowEntity.seriesNumber.length % this.editPagination.pageSize === 1) {
          aimCurrentPage -= 1;
        }
      }
      // 删除操作
      this.editFlowEntity.seriesNumber.splice(index, 1);
      this.editPagination.currentPage = aimCurrentPage;
    },
    // 批量删除
    patchDelete() {
      if (this.idsArr.length === 0) {
        this.$msg('请勾选需要删除的序列号', 'warning');
        return;
      }

      // 删除最后一页全部数据导致页数减少的情况，前跳一页（第一页不跳），否则搜不出数据
      if (this.seriesNumberPagination.currentPage > 1) {
        let maxPage = Math.ceil(this.form.seriesNumber.length / this.seriesNumberPagination.pageSize);
        if (this.seriesNumberPagination.currentPage === maxPage) { // 处在最后一页
          // 最后一页数据量
          let sumInLastPage = this.form.seriesNumber.length % this.seriesNumberPagination.pageSize;
          // 全选删除，页码必然减少，!sumInLastPage 是最后一页数据量刚好等于pageSize的情况
          if (!sumInLastPage || this.idsArr.length === sumInLastPage) {
            this.seriesNumberPagination.currentPage -= 1;
          }
        }
      }

      this.form.seriesNumber = this.form.seriesNumber.filter(item => !this.idsArr.includes(item.id));
    },
    // 批量删除-编辑
    patchDeleteInEdit() {
      if (this.idsArrInEdit.length === 0) {
        this.$msg('请勾选需要删除的序列号', 'warning');
        return;
      }

      // 删除最后一页全部数据导致页数减少的情况，前跳一页（第一页不跳），否则搜不出数据
      if (this.editPagination.currentPage > 1) {
        let maxPage = Math.ceil(this.editFlowEntity.seriesNumber.length / this.editPagination.pageSize);
        if (this.editPagination.currentPage === maxPage) { // 处在最后一页
          // 最后一页数据量
          let sumInLastPage = this.editFlowEntity.seriesNumber.length % this.editPagination.pageSize;
          // 全选删除，页码必然减少，!sumInLastPage 是最后一页数据量刚好等于pageSize的情况
          if (!sumInLastPage || this.idsArrInEdit.length === sumInLastPage) {
            this.editPagination.currentPage -= 1;
          }
        }
      }

      this.editFlowEntity.seriesNumber = this.editFlowEntity.seriesNumber.filter(item => !this.idsArrInEdit.includes(item.id));
    },
    //=========================上传图片相关的=========================
    // 图片预览按钮的效果
    handlePictureCardPreview() {
      this.imgPreviewVisible = true;
    },
    // 图片预览按钮的效果-编辑
    handlePictureCardPreviewInEdit() {
      this.imgPreviewVisibleInEdit = true;
    },
    // 上传图片
    uploadImage(params) {
      let formData = new FormData()
      formData.append('image', params.file)
      uploadImage(formData).then(res => {
        if (res.returnCode === '100') {
          res = res.returnData;
          this.form.orderImg.imageUrl = res.imageUrl;
          this.form.orderImg.imageUrlArr = [{ url: res.imageUrl }];
        } else {
          this.$msg(res.returnMsg, 'error');
          this.handleRemoveImage();
        }
      }).catch(err => {
      })
    },
    // 上传图片-编辑
    uploadImageInEdit(params) {
      let formData = new FormData()
      formData.append('image', params.file)
      uploadImage(formData).then(res => {
        if (res.returnCode === '100') {
          res = res.returnData;
          this.editFlowEntity.orderImg.imageUrl = res.imageUrl;
          this.editFlowEntity.orderImg.imageUrlArr = [{ url: res.imageUrl }];
        } else {
          this.$msg(res.returnMsg, 'error');
          this.handleRemoveImageInEdit();
        }
      }).catch(err => {
      })
    },
    // 移除图片
    handleRemoveImage() {
      this.form.orderImg.imageUrl = '';
      this.form.orderImg.imageUrlArr = [];
    },
    // 移除图片-编辑
    handleRemoveImageInEdit() {
      this.editFlowEntity.orderImg.imageUrl = '';
      this.editFlowEntity.orderImg.imageUrlArr = [];
    },
    // 上传图片前
    beforeUploadImage(file) {
      const typeAccept = (file.type === 'image/jpeg') || (file.type === 'image/png') ||
        (file.type === 'image/jpg');
      const sizeAccept = file.size / 1024 / 1024 <= 2;
      if (!typeAccept) {
        this.$msg('上传文件的格式只能是：jpg、png、jpeg');
      }
      if (!sizeAccept) {
        this.$message.error('上传文件的大小不能超过2MB!');
      }
      return typeAccept && sizeAccept
    },
    //=========================上传图片相关的=========================

    // 根据销售类行更改工程地点
    changeAddrOPE(val) {
      let aimLabel = '';
      for (let item of this.selection.salesTypes) {
        if (item.value == val) {
          aimLabel = item.label;
          break;
        }
      }
      if (aimLabel == '出口') {
        this.addrLabel = '工程地点';
        this.showProvinceCity = false;
      } else {
        this.addrLabel = ' ';
        this.showProvinceCity = true;
      }
    },
    // 根据销售类行更改工程地点-编辑
    changeAddrOPEInEdit(val) {
      let aimLabel = '';
      for (let item of this.selection.salesTypes) {
        if (item.value == val) {
          aimLabel = item.label;
          break;
        }
      }
      if (aimLabel == '出口') {
        this.addrLabelInEdit = '工程地点';
        this.showProvinceCityInEdit = false;
      } else {
        this.addrLabelInEdit = ' ';
        this.showProvinceCityInEdit = true;
      }
    },

    newsTableSizeChange(val) {
      this.flowPagination.pageSize = val;
    },
    newsTableCurrentChange(val) {
      this.flowPagination.currentPage = val;
    },
    newsJumpToPage() {
      this.flowPagination.currentPage = this.flowPagination.jumpPage;
    },


    /**
     * @Description:
     * @author Li Yanjie
     * @date 2020/7/14
     * @param page {Boolean} true是注册申请页面、false是流程管理页面
     * @return
     */
    changePage(page) {
      this.showRegister = page;
      this.resetFrom();
      if (page === false) {
        this.searchData();
      }
    },


    /**
     * @Description: 改变选择的省
     * @author Li Yanjie
     * @date 2020/7/8
     * @param val {String} 选择的省的id
     * @return
     */
    changeProvince(val) {
      this.selection.cities = city[val];
      this.form.city = '';
    },
    changeProvinceInEdit(val) {
      this.editSelection.cities = city[val];
      this.editFlowEntity.city = '';
    },

    // 遍历序列号列表寻空，并跳到指定页面，记录编辑弹窗用
    searchEmptyActiveCodeInDialog() {
      for (let i = 0; i < this.editFlowEntity.seriesNumber.length; i++) {
        let item = this.editFlowEntity.seriesNumber[i].number;
        if (!item) {
          this.editPagination.currentPage = Math.ceil((i + 1) / this.editPagination.pageSize);
          return true;
        }
      }
      return false;
    },
    // 遍历序列号列表寻空，并跳到指定页面
    searchEmptyActiveCode() {
      for (let i = 0; i < this.form.seriesNumber.length; i++) {
        let item = this.form.seriesNumber[i].number;
        if (!item) {
          this.seriesNumberPagination.currentPage = Math.ceil((i + 1) / this.seriesNumberPagination.pageSize);
          return true;
        }
      }
      return false;
    },
    // 提交前的判断逻辑-弹窗
    async beforeConfirmInDialog(push) {
      let activeCodeHasEmpty = false;
      if (!this.setMealIsLogicInDialog) { // 使用了表格式的序列号才进行校验
        activeCodeHasEmpty = this.searchEmptyActiveCodeInDialog();
        if (activeCodeHasEmpty) {
          this.$nextTick(() => {
            this.$refs['dialogForm'].validate((valid) => {
              if (valid) {
              } else {
                // return false;
              }
            });
          })
        }
      }
      let error1 = false;
      this.$refs['applyForm'].validate((valid) => {
        if (valid) {
        } else {
          error1 = true;
          // return false;
        }
      });
      if (error1 || activeCodeHasEmpty) {

      } else if (this.setMealIsLogicInDialog && false) {  // 注册logic的判断，临时屏蔽该校验逻辑
        let activeNum = await this.checkUserActiveLogic();  // 接口获取激活次数
        if (activeNum > 1) {  // 禁止激活
          this.$confirm('很抱歉，您的激活次数已用尽！<br>注：1个账号仅允许激活GMVisual Logic1次',
            '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString: true,
            type: 'error'
          }).then(() => { }).catch(e => e);
        } else {  // 激活提示
          this.$confirm('每个账号仅支持申请激活1台GMVisual Logic软件，请确认是否激活？',
            '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.applyInEdit(push);
          }).catch(e => e);
        }
      } else {  // 正常提交注册逻辑
        this.applyInEdit(push);
      }
    },
    // 提交注册前的判断逻辑
    async beforeConfirm() {
      let activeCodeHasEmpty = false;
      if (!this.setMealIsLogicInPage) {
        activeCodeHasEmpty = this.searchEmptyActiveCode();
        if (activeCodeHasEmpty) {
          this.$nextTick(() => {
            this.$refs['regForm'].validate((valid) => { // 序列号表单校验
              if (valid) {
              } else {
                // return false;
              }
            });
          })
        }
      }
      let error1 = false;
      await this.$refs['productForm'].validate((valid) => { // 整体表单校验
        if (valid) {
          console.log(1)
        } else {
          console.log(2)
          error1 = true;
          // return false;
        }
      });
      console.log('this.setMealIsLogicInPage', this.setMealIsLogicInPage, 'error1', error1, 'activeCodeHasEmpty', activeCodeHasEmpty, 'this.form.belongToProject', this.form.belongToProject === '',)


      if (error1 || activeCodeHasEmpty || (this.form.belongToProject === '' && !this.setMealIsLogicInPage) || (this.form.addressDetail === '' && !this.setMealIsLogicInPage)) {

      } else if (this.setMealIsLogicInPage && false) {  // 注册logic的判断，临时屏蔽该校验逻辑
        let activeNum = await this.checkUserActiveLogic();  // 接口获取激活次数
        if (activeNum > 1) {  // 禁止激活
          this.$confirm('很抱歉，您的激活次数已用尽！<br>注：1个账号仅允许激活GMVisual Logic1次',
            '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString: true,
            type: 'error'
          }).then(() => { }).catch(e => e);
        } else {  // 激活提示
          this.$confirm('每个账号仅支持申请激活1台GMVisual Logic软件，请确认是否激活？',
            '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.registerProductL();
          }).catch(e => e);
        }
      } else {  // 正常提交注册逻辑
        this.registerProductL();
      }
    },
    /**
     * @Description: 提交注册-新
     */
    registerProductL() {
      let seriesNumberArr = [];
      for (let item of this.form.seriesNumber) {
        seriesNumberArr.push(item.number);
      }
      let data = {
        productType: this.form.productType,
        productPackage: this.form.productSetMeal,
        productPointType: this.form.productPointType,
        market: this.form.salesType,
        engineeringName: this.form.belongToProject,
        engineeringAddress: this.form.addressDetail,
        orderNumber: this.form.orderNumber,
        orderImage: this.form.orderImg.imageUrl,  // 非必填
        proposer: this.proposer,
        // applicationOrganization: this.form.applicationUnit,
        remark: this.form.remark,
      };
      // 找到正确的序列号放入
      data.productSerialNumber = this.setMealIsLogicInPage ? this.form.seriesNumberOnce : seriesNumberArr.join(' ');
      // 内销才有省市
      if (this.form.salesType === 1 && !this.setMealIsLogicInPage) {
        let cityName = '';
        let provinceName = '';
        if (this.form.province) {
          cityName = city[this.form.province]?.find(item => item.id === this.form.city).name ?? '';
          provinceName = province?.find(item => item.id === this.form.province).name ?? '';
          data.province = provinceName;
          data.city = cityName;
        }
      }
      // GMVisual Logic申请时，禁用项全部置为空
      if (this.setMealIsLogicInPage) {
        data.orderNumber = '';
        data.orderImage = '';
        data.engineeringName = '';
        data.province = '';
        data.city = '';
        data.engineeringAddress = '';
      }
      registerProductNew(data).then(res => {
        // 给出成功提示弹窗
        this.registerResultCode = res.returnCode;
        this.successRegister = true;
        if (res.returnCode === '100') {
          this.resetFrom();
          this.getApplyRecordTable();
          this.changePage(false); // 切换到流程管理页面
        }

      }).catch(e => {

      })
    },
    /**
     * @Description: 提交注册
     * @author Li Yanjie
     * @date 2020/7/14
     */
    registerProduct() {
      let error = false;
      this.$refs['productForm'].validate((valid) => {
        if (valid) {

        } else {
          error = true;
          return false;
        }
      });
      if (error) {
        return;
      }
      let cityName = '';
      let provinceName = '';
      cityName = city[this.form.province].find(item => item.id === this.form.city).name;
      provinceName = province.find(item => item.id === this.form.province).name;
      let data = {
        city: cityName,
        engineeringAddress: this.form.addressDetail,
        market: this.form.salesType,
        orderNumber: this.form.orderNumber,
        productSerialNumber: this.form.activeCode,
        productType: this.form.productType,
        proposer: this.getUserName,
        province: provinceName,
      };
      registerProduct(data).then(res => {
        this.registerResultCode = res.returnCode;
        this.successRegister = true;
        if (res.returnCode === '100') {
          this.resetFrom();
          this.getFlowTable();
        }

      }).catch(e => {

      })
    },


    /**
     * @Description: 重置表单
     * @author Li Yanjie
     * @date 2020/7/14
     */
    resetFrom() {
      this.form.productType = '';
      this.form.productSetMeal = '';
      this.selection.productSetMeals = [];
      this.form.productPointType = '';
      this.selection.pointTypes = [];
      this.form.salesType = 1;
      this.form.belongToProject = '';
      // this.form.applicationUnit = '';
      this.form.province = '';
      this.form.city = '';
      this.form.addressDetail = '';
      this.form.orderNumber = '';
      this.form.orderImg.imageUrl = '';
      this.form.orderImg.imageUrlArr = [];
      // this.form.orderImg = {
      //   imageUrl: '',
      //   imageUrlArr: [
      //     // {'url':'http://172.16.200.156:8088/apis/api/cafca97472454cd7b7651362832557b5.png'}
      //   ],  // 图片上传组件的绑定值需为list
      // };
      this.form.remark = '';
      this.form.seriesNumber = [];
      this.form.seriesNumberOnce = '';
      this.setMealIsLogicInPage = false;
      this.$refs['productForm'].clearValidate();
      this.addRow();
    },

    // 更新提交记录-旧
    getFlowTable() {
      let _this = this;
      getRegisterByProposer(this.getUserName).then(res => {
        if (res.returnCode === '100') {
          let arr = [];
          res.returnData.map((item, index) => {
            arr.push({
              no: index + 1,
              type: _this.typeCache[item.productType],
              flowType: item.productType,
              flowStatus: item.flowStatus,
              time: item.applicationTime,
              downCode: item.productSerialNumber,
              registerId: item.registerId
            })
          });
          this.flowTableData = arr;
        } else {
          this.flowTableData = [];
        }

      }).catch(err => {

      })
    }
  },
  created() {
    this.initProductOption();
    this.getApplyRecordTable();
  },
  mounted() {
    this.addRow();

    this.selection.provinces = province;
    this.getFlowTable();
  }
}
</script>
<style scoped lang="less">
// 禁用选择框样式
/deep/ .el-select.disabledSelect .el-input.is-disabled {
  .el-input__inner {
    border-color: #5a89e3;
  }
}

// 禁用选择框样式-弹窗
/deep/ .el-select.disabledSelectInDialog .el-input.is-disabled {
  .el-input__inner {
    border-color: #e4e7ed;
  }
}

//禁用上传图片组件样式
.avatar-uploader.disabledUpload {
  /deep/ .el-upload.el-upload--picture-card {
    cursor: not-allowed;
    background-color: #f5f7fa;
    border-color: #c0cdda;
  }
}

//模拟必填小红星
.mockMust.el-form-item {
  /deep/ .el-form-item__label:before {
    content: '*';
    color: #f56c6c;
    margin-right: 4px;
  }
}

/deep/ .cellStyle .cell {
  word-break: break-word;
}

.ml10 {
  margin-left: 10px;
}

.searchTitle {
  font-size: 16px;
}

.editPCStyle {
  display: flex;
}

/deep/ .editPCStyle .el-form-item__content {
  margin-left: 0 !important;
}

/*查看详情样式*/
.attrItem {
  margin-bottom: 22px;
  text-align: left;

  /*标题样式*/
  .attrTitle {
    display: inline-block;
    width: 160px;
    padding-right: 12px;
    text-align: right;
    box-sizing: border-box;
    font-size: 18px;
    color: #224E7F;
    vertical-align: top;
  }

  /*数值样式*/
  .attrValue {
    display: inline-block;
    font-size: 16px;
    color: #333333;
    box-sizing: border-box;
    width: 350px;
    line-height: 27px;
    padding-left: 30px;
    word-break: break-word;
  }
}

/*详情弹窗标题样式*/
.dialogTitle {
  font-size: 18px;
  color: #224E7F;
  text-align: left;
  font-weight: bold;
  border-bottom: 1px solid #EEEEEE;
}

.banUse {
  color: #bbb9b9 !important;
  cursor: not-allowed !important;
}

.canUse {
  cursor: pointer;
  color: #31A4FF;
}

.downloadBtn {
  margin-left: 10px;
  border-bottom: 1px solid #31A4FF;
}

.topBar {
  text-align: right;
}

.opeBar {
  text-align: right;
  margin-bottom: 10px;
}

.btnMr {
  margin-right: 10px;
}

/*按钮样式*/
.btnForPub {
  background-color: #3399FF;
  color: #FFFFFF;
  font-size: 16px;
  height: 40px;
  width: 120px;
  line-height: 40px;
  display: inline-block;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
}

/*操作按钮样式*/
.opeBtn {
  display: inline-block;
  cursor: pointer;
  color: #31A4FF;
}

/*增加图标*/
.leftIcon1 {
  position: absolute;
  right: -45px;
  top: 5px;
  display: inline-block;
  font-size: 30px;
  font-weight: bold;
  cursor: pointer;
}

/*减少图标*/
.leftIcon2 {
  position: absolute;
  right: -85px;
  top: 5px;
  display: inline-block;
  font-size: 30px;
  font-weight: bold;
  cursor: pointer;
}

/*上传图片框隐藏逻辑样式*/
/deep/ .onlyOneImgUploader .el-upload--picture-card {
  display: none;
  /* 上传按钮隐藏 */
}

/*对齐必填标签*/
/deep/ .transparentStar .el-form-item__label::before {
  content: '*';
  color: transparent;
  margin-right: 4px;
}
</style>
<style scoped lang="less">
.registerFailIcon {
  font-size: 28px;
  color: #F56C6C;
}

.serve1 {
  .x-top {
    padding: 0;
    min-height: 23rem;

    .x-top-img {
      text-align: right;

      img {
        width: 20rem;
      }
    }
  }

  /*工程地点*/
  .eng {
    display: flex;
    flex-wrap: wrap;

    span {
      display: inline-block;
      text-align: left;
      font-size: 0.8rem;

      &.tit {
        line-height: 40px;
        color: @deepblue;
        width: 7.5rem;

        &:before {
          color: #F56C6C;
          margin-right: 4px;
          content: "*";
        }
      }
    }

    .row2 {
      display: flex;
      flex-wrap: wrap;
      width: 80%;
    }
  }

  .title {
    /*display: inline-block;*/
    /*width: 80%;*/
    padding-bottom: 2rem;
    box-sizing: border-box;
    text-align: left;
    color: @deepblue;
    font-size: 1rem;
  }

  /*表格*/
  .form {
    margin: auto;
    width: 90%;
    /*padding: 2rem;*/
    text-align: left;
    box-sizing: border-box;

    .top {
      input {
        width: 40%;
      }
    }

    /*了解更多按钮*/
    .x-btn {
      text-align: center;
      display: inline-block;
      color: #fff;
      background-image: linear-gradient(to right, rgb(112, 68, 249), rgb(84, 106, 238));
      width: 4rem;
      border-radius: 50px;
      padding: 0.5rem 2rem 0.5rem 2rem;
      margin-top: 1rem;
      cursor: pointer;
    }
  }

  /*头部背景图*/
  .bakTop {
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
  }
}

.changePageButtonContainer {
  text-align: left;
  padding-left: 115px;
}

.changePageButton {
  display: inline-block;
  font-size: 19px;
  margin-bottom: 28px;
  position: relative;
  text-align: center;

  .pageBtn {
    display: inline-block;
    font-weight: bold;
    background-color: #ffffff;
    color: #5c89e5;
    padding: 7px 14px;
    cursor: pointer;

    &.active {
      background-color: #5c89e5;
      color: #ffffff;
    }

    &:first-child {
      box-shadow: 1px 2px 6px 0px #636363;
      border-top-left-radius: 32px;
      border-bottom-left-radius: 32px;
      padding-left: 20px;
    }

    &:last-child {
      box-shadow: 1px 2px 6px 0px #636363;
      border-top-right-radius: 32px;
      border-bottom-right-radius: 32px;
      padding-right: 20px;
    }

  }

  .point {
    height: 12px;
    width: 12px;
    background-color: #2c53b0;
    border-radius: 50%;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    margin: auto;
  }
}

.registerTableContainer {
  box-shadow: 2px 2px 9px 0px rgba(0, 0, 0, 0.2);
  padding: 28px;
  box-sizing: border-box;
  border-radius: 8px;
  background-color: #FFF;
}
</style>
<style lang="less">
.serve1 {
  .x-container {
    padding-top: 0;
    @media (min-width: 1200px) {
      width: 1600px !important;
    }
    section {
      width: 80%;
      margin: auto;
    }

    .productRegister {
      .el-form--inline .el-form-item__label {
        color: @deepblue;
        font-size: 0.8rem;
      }

      .el-input__inner {
        border: 1px solid @blue;
        border-radius: 0;
      }

      /*工程地点*/
      .engineeringAddress {
        margin-right: 2rem;

        .el-form-item__content {
          width: auto;
        }
      }

      /*产品类型*/
      .productType {
        .el-form-item__content {
          width: 80%;

          .el-select {
            width: 100%;
          }
        }
      }

      /*详细地址*/
      .addressDetail {
        .el-form-item__content {
          width: 80%;
        }
      }

      /*激活码*/
      .activedCode {
        .el-form-item__content {
          width: 80%;
        }
      }

      .el-textarea__inner {
        /*min-height: 10rem !important;*/
        border: 1px solid @blue;
        border-radius: 0;
      }

      .textarea {
        .el-form-item__content {
          width: 100%;
        }

        .el-form-item__label {
          margin-bottom: 1rem;
        }
      }
    }
  }
}
</style>
<style lang="less">
.serve1 {
  @media only screen and (min-width: 320px) {
    form {
      width: 100% !important;

      .row2 {
        width: 100% !important;

        .engineeringAddress {
          margin-right: 0 !important;
        }
      }

      .title {
        display: inline-block !important;
        width: 100% !important;
        padding-bottom: 2rem !important;
        box-sizing: border-box !important;
        text-align: left !important;
        color: @deepblue !important;
        font-size: 1rem !important;
      }
    }
  }

  @media only screen and (min-width: 768px) {
    form {

      /*width: 90%!important;*/
      .row2 {
        width: 80% !important;

        .engineeringAddress {
          margin-right: 2rem !important;
        }
      }

      .title {
        display: inline-block !important;
        /*width: 90%!important;*/
        padding-bottom: 2rem !important;
        box-sizing: border-box !important;
        text-align: left !important;
        color: @deepblue !important;
        font-size: 1rem !important;
      }
    }
  }
}

.product_registration_selection .el-input__suffix {
  right: 0;
  background: #5a89e3;
}

.product_registration_selection.el-select .el-input .el-select__caret {

  width: 40px;
  color: #fff;
}
</style>
<style lang="less">
.flowTableHeader {
  font-weight: bold;
  /*color: #292929;*/
}

.flowTableClass.el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #f5faff;
}

.el-table--enable-row-hover .el-table__body tr:hover>td {
  background-color: #f5faff;
}
</style>
<style lang="less" scoped>
.loginDialog__wrap {
  box-shadow: 3px 3px 7px 0 rgba(0, 0, 0, 0.2);
  border-right: 4px;
  background-color: transparent;

  &__title {
    position: relative;
    font-size: 20px;
    background-color: #5c89e5;
    color: #ffffff;
    font-weight: bold;
    padding: 12px 36px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;

    .el-icon-close {
      position: absolute;
      right: 8px;
      top: 0;
      bottom: 0;
      margin: auto;
      cursor: pointer;
      font-size: 28px;
      height: 28px;
    }
  }

  &__content {
    padding: 20px 36px 20px 36px;
    background-color: #fff;

    .tips {
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
    }

    .smallbtn {
      font-size: 13px;
      color: #5c89e5;
      padding-top: 2px;
      display: inline-block;
      cursor: pointer;

      &.line {
        border-bottom: 2px solid;
        /*padding-bottom: 2px;*/
      }
    }

    .login-btn-container {
      text-align: right;
      margin: 12px auto;
    }

    .login-btn {
      display: inline-block;
      background-color: #5c89e5;
      border-radius: 6px;
      padding: 6px 24px;
      color: #ffffff;
      font-size: 17px;
      cursor: pointer;

    }
  }
}
</style>

<style>
.loginDialog .el-dialog {
  background-color: transparent;
  box-shadow: none;
}

.loginDialog .el-dialog--center .el-dialog__body {
  padding: 0;
  background-color: transparent;
}

.loginDialog.el-dialog__wrapper .el-dialog__header {
  display: none;
}

.loginDialog.el-dialog__wrapper .el-dialog__body .el-dialog__headerbtn {
  display: none;
}

.el-form-item.noRequiredFlag.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label:before,
.el-form-item.noRequiredFlag.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
  content: "";
}
</style>
<!--流程图样式-->
<style lang="less" scoped>
/* 流程信息 */
.steps-conatiner {
  display: inline-block;
  width: 40px;
  vertical-align: top;
}

.steps-content-container {
  display: inline-block;
  /*height: 260px;*/
  width: 500px;
  vertical-align: top;
  margin-top: -28px;
}

.steps-content {
  height: 60px;
  margin-bottom: 42px;
  border: 1px solid #bebebe;
  padding: 10px;
  position: relative;
  display: flex;
}

.steps-content-approver {
  min-height: 60px;
  margin-bottom: 42px;
  border: 1px solid #bebebe;
  padding: 10px;
  position: relative;
}

.step-time {
  position: absolute;
  top: 12px;
  right: 12px;
  font-weight: bold;
  font-size: 16px;
}

/deep/ .relativeError .el-form-item__error {
  position: relative;
  text-align: left;
}

/deep/ .moreWidth>.el-form-item__content {
  margin-left: 4.5rem !important;
}

@media (max-width: 767px) {
  .serve1 .x-container section {
    width: 100%;
  }

  .serve1 .productRegister .el-form-item__content {
    width: 100% !important;
  }

  .serve1 .productRegister .el-form--inline .el-form-item {
    width: 100%;
    margin-right: 0;
  }
}
</style>
